// MapComponent.js
import React, { useEffect, useRef, useState, useCallback } from "react";
import mapboxgl from "mapbox-gl";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder"; // Import Mapbox Geocoder
import { Chart, CategoryScale, LinearScale } from "chart.js/auto";
import { toast } from "react-toastify";
import * as turf from "@turf/turf";
import Header from "./Header";
import { jwtDecode } from "jwt-decode";
import Spinner from "./Spinner";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ReactSlider from "react-slider";
import FilterListIcon from "@mui/icons-material/FilterList"; // You can use any icon
import ButtonFilter from "./ButtonFilter"; // Import the child component
import TextField from '@mui/material/TextField';
import ParcelScreen from "./ParcelScreen";
import {
  Slider,
  Typography,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";
import ConfirmModal from "./ConfirmModal"; // Import the child component
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { List, AutoSizer } from "react-virtualized";
import Modal from "react-modal";
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import { Favorite } from "@mui/icons-material";
mapboxgl.accessToken =
  "pk.eyJ1IjoiYWJoaWppdGgxMjc5IiwiYSI6ImNtNGNqdzE4NDA2MGoyaXFwdXh6cjVqMWQifQ.OpRKi-Zt3NIOjXFz-hd-DA";

const PointScreen = () => {
  const mapContainer = useRef(null);
  const [popupInstance, setPopupInstance] = useState(null); // Default to 0

  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [propertyList, setPropertyList] = useState([]);
  const [featureList, setFeatureList] = useState([]);
  const [showROIFilter, setShowROIFilter] = useState(false);
  const [showAppreciationFilter, setShowAppreciationFilter] = useState(false);

  const [activeMetric, setActiveMetric] = useState("roi");
  const [metricControl, setMetricControl] = useState(null);
  const [legendControl, setLegendControl] = useState(null);
  const [featureData, setFeatureData] = useState([]);
  const [favoriteZipcodes, setFavoriteZipcodes] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const popupRef = useRef(null);
  const [popupData, setPopupData] = useState(null);
  const [searchPincode, setSearchPincode] = useState("");
  const customPopupRef = useRef(null);
  const [currentStateId, setCurrentStateId] = useState(null);
  const [currentCity, setCurrentCity] = useState(null);
  const [currentPopup, setCurrentPopup] = useState(null);
  let isFavorite = false;
  const [popupHTML, setPopupHTML] = useState("");
  const [originalPropertyList, setOriginalPropertyList] = useState([]);
  const [compareList, setCompareList] = useState([]);
  const [currentView, setCurrentView] = useState("split"); // default is split view
  const [selectedZipcode, setSelectedZipcode] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(
    localStorage.getItem("isSubscribed") === "true"
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [styleLoaded, setStyleLoaded] = useState(false); // Flag to track style load status
  const [isFullWidth, setIsFullWidth] = useState(false);
  const [roiFilter, setRoiFilter] = useState("All"); // State for ROI filter
  const [appreciationFilter, setAppreciationFilter] = useState("All"); // State for Appreciation filter
  const [scoreFilter, setScoreFilter] = useState("All"); // State for Score filter

  const [showScoreFilter, setShowScoreFilter] = useState(false);
  const [showPriceFilter, setShowPriceFilter] = useState(false);
  const [sliderMinSales, setSliderMinSales] = useState(null); // Default to 0
  const [sliderMaxSales, setSliderMaxSales] = useState(null); // Default to 0
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [zipToRemove, setZipToRemove] = useState(null);
  const [isCompareClicked, setIsCompareClicked] = useState(false); // State to manage compare option visibility
  const [checkedItems, setCheckedItems] = useState({});
  const authToken = localStorage.getItem("authToken");
  const [usaGeoJson, setUsaGeoJson] = useState(null);
  const [forceRerender, setForceRerender] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const geocoderContainerRef = useRef(null);
  const [minSales, setMinSales] = useState(null); // Default to 0
  const [sortKey, setSortKey] = useState("roi"); // default sort by roi
  const [sortOrder, setSortOrder] = useState("desc"); // ascending order
  const [maxSales, setMaxSales] = useState(null); // Default to 0
  const [loading, setLoading] = useState(true);
  const popupChartRef = useRef(null);
  const popupChartListRef = useRef(null);
  const navigate = useNavigate();
  const [showEulaModal, setShowEulaModal] = useState(false);
  // Add this state and ref at the top with other state declarations
  const [isLoadingFeatures, setIsLoadingFeatures] = useState(false);
  const fetchTimeoutRef = useRef(null);
  const [htmlContent, setHtmlContent] = useState("");
  const scrollRef = useRef(null);
  const [canAccept, setCanAccept] = useState(false);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [favoritePropertyList, setFavoritePropertyList] = useState([]);
  const [updatedFavoritePropertyList, setUpdatedFavoritePropertyList] = useState([]);
const [crimeIndexFilter, setCrimeIndexFilter] = useState("");
const [applyClicked, setApplyClicked] = useState(false);
// const [roiFilterTemp, setRoiFilterTemp] = useState(70);        // temporary value while dragging
// const [appreciationFilterTemp, setAppreciationFilterTemp] = useState(30); // temporary
// const [fliROIFilter, setFliROIFilter] = useState(70);     // actual applied filter
// const [fliApprFilter, setFliApprFilter] = useState(30);   // actual applied filter
const [fliROIFilter, setFliROIFilter] = useState(() => {
  const saved = localStorage.getItem("fliROIFilter");
  return saved !== null ? Number(saved) : 70;
}); // actual applied filter

const [fliApprFilter, setFliApprFilter] = useState(() => {
  const saved = localStorage.getItem("fliApprFilter");
  return saved !== null ? Number(saved) : 30;
}); // actual applied filter

const INITIAL_ROI = localStorage.getItem("fliROIFilter") !== null
  ? Number(localStorage.getItem("fliROIFilter"))
  : 80;
const INITIAL_APPRECIATION = localStorage.getItem("fliApprFilter") !== null
  ? Number(localStorage.getItem("fliApprFilter"))
  : 20;

// Use these for initial values everywhere
const [roiFilterTemp, setRoiFilterTemp] = useState(INITIAL_ROI);
const [appreciationFilterTemp, setAppreciationFilterTemp] = useState(INITIAL_APPRECIATION);

const [showFLISection, setShowFLISection] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the menu visibility
  };
  const activeFilterCount = [
    roiFilter !== "All",
    appreciationFilter !== "All",
    scoreFilter !== "All",
    minSales !== sliderMinSales,
    maxSales !== sliderMaxSales,
  ].filter(Boolean).length;
  const roiColors = {
    roi: [
      { color: "#acacac", label: "0" },
      { color: "#FFE36B", label: "5" },
      { color: "#FFB36B", label: "10" },
      { color: "#FE5C5C", label: "15" },
      { color: "#F26BFF", label: "20" },
      { color: "#CE1E50", label: "25" },
    ],
    appreciation: [
      { color: "#acacac", label: "All" },
      { color: "#FFE36B", label: "0" },
      { color: "#FFB36B", label: "5" },
      { color: "#FE5C5C", label: "10" },
      { color: "#F26BFF", label: "15" },
      { color: "#CE1E50", label: "20" },
    ],
    score: [
      { color: "#acacac", label: "0" },
      { color: "#FFE36B", label: "7" },
      { color: "#FFB36B", label: "10" },
      { color: "#FE5C5C", label: "15" },
      { color: "#F26BFF", label: "20" },
      { color: "#CE1E50", label: "25" },
    ],
  };

const [includeAdditionalFeatures, setIncludeAdditionalFeatures] = useState(false);
const [additionalFeatureWeight, setAdditionalFeatureWeight] = useState(20); // Default 20%
const [additionalFeatureList, setAdditionalFeatureList] = useState([
  { key: "crimeIndex", label: "Crime Index", enabled: true, weight: 5, type: "negative" },
  { key: "climaticDistress", label: "Climatic Distress Index", enabled: true, weight: 5, type: "negative" },
  { key: "employability", label: "Employability Index", enabled: true, weight: 5, type: "positive" },
  { key: "education", label: "Education Index", enabled: true, weight: 5, type: "positive" },
]);
const [view, setView] = useState("default"); // 'default' or 'land'

  const handleToggle = () => {
    setView(view === "default" ? "land" : "default");
  };

const handleAgree = async () => {
    //  setShowPdfModal(false)
    setShowEulaModal(false);

    try {
      const response = await fetch(
        "https://beta.flowlogic.com/api/users/accept-eula/",
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`, // usually expected
          },
          body: JSON.stringify({ eula_accepted: true }), // send as boolean
        }
      );

      const data = await response.json().catch(() => ({})); // handle empty JSON

      if (!response.ok) {
        console.error("Accept EULA failed:", data);
        throw new Error(`Request failed with status ${response.status}`);
      }

      console.log("EULA API Response:", data);

      if (data.message === "EULA accepted successfully") {
        localStorage.setItem("eula_accepted", "true");
        // setShowPdfModal(false);
        setShowEulaModal(false);
      }
    } catch (error) {
      console.error("Error accepting EULA:", error);
    }
  };

  // Simple debounced version without Promise handling
  const debouncedFetchFeatureData = useCallback(() => {
    if (fetchTimeoutRef.current) {
      clearTimeout(fetchTimeoutRef.current);
    }

    fetchTimeoutRef.current = setTimeout(() => {
      if (!isLoadingFeatures && typeof fetchFeatureData === "function") {
        setIsLoadingFeatures(true);
        fetchFeatureData();
        // Reset loading state after a short delay
        setTimeout(() => setIsLoadingFeatures(false), 100);
      }
    }, 300); // 300ms debounce delay
  }, [isLoadingFeatures]);

  // //update circle color when change activemetric
  // function updateCircleColor(metric) {
  //   if (map && map.getLayer("point-layer")) {
  //     map.setPaintProperty("point-layer", "circle-color", [
  //       "step",
  //       ["get", metric],
  //       "#acacac",
  //       0,
  //       "#acacac",
  //       5,
  //       "#FFE36B",
  //       10,
  //       "#FFB36B",
  //       15,
  //       "#FE5C5C",
  //       20,
  //       "#F26BFF",
  //       25,
  //       "#CE1E50",
  //     ]);
  //   }
  // }
  function updateCircleColor(metric) {
  if (map && map.getLayer("point-layer")) {
    // Define color steps based on metric
    const paintExpression =
      metric === "appreciation"
        ? [
            "step",
            ["get", "appreciation"],
            "#acacac",  // fallback/default color
            0, "#FFE36B",
            5, "#FFB36B",
            10, "#FE5C5C",
            15, "#F26BFF",
            20, "#CE1E50"
          ]
        : [
            "step",
            ["get", metric],
            "#acacac",
            0, "#acacac",
            5, "#FFE36B",
            10, "#FFB36B",
            15, "#FE5C5C",
            20, "#F26BFF",
            25, "#CE1E50"
          ];

    // Apply the color style to the map layer
    map.setPaintProperty("point-layer", "circle-color", paintExpression);
  }
}


  function formatCurrency(value) {
    if (value >= 1e6) {
      return "$" + Math.floor(value / 1e6) + "M"; // For millions
    } else if (value >= 1e3) {
      return "$" + Math.floor(value / 1e3) + "k"; // For thousands
    } else {
      return "$" + Math.floor(value).toLocaleString(); // For values less than 1000
    }
  }

//   useEffect(() => {
//   if (includeAdditionalFeatures) {
//     const remaining = 100 - additionalFeatureWeight;
//     setRoiFilterTemp(Math.round(remaining / 2));
//     setAppreciationFilterTemp(Math.round(remaining / 2));
//   }
// }, [additionalFeatureWeight, includeAdditionalFeatures]);
useEffect(() => {
  if (includeAdditionalFeatures) {
    // Initial values before enabling additional features
    const initialROI = 70;
    const initialAppreciation = 30;
    // Reduce half of additionalFeatureWeight from each
    const reduction = Math.round(additionalFeatureWeight / 2);
    // setRoiFilterTemp(initialROI - reduction);
    // setAppreciationFilterTemp(initialAppreciation - reduction);
     setRoiFilterTemp(INITIAL_ROI - reduction);
    setAppreciationFilterTemp(INITIAL_APPRECIATION - reduction);
  }
  // else {
  //     const reduction = Math.round(additionalFeatureWeight / 2);
  //   // When disabling: add back the reduction
  //   setRoiFilterTemp(prev => Math.min(prev + reduction, 100));
  //   setAppreciationFilterTemp(prev => Math.min(prev + reduction, 100));
  // }
   else {
    // Restore previous values
    setRoiFilterTemp(INITIAL_ROI);
    setAppreciationFilterTemp(INITIAL_APPRECIATION);
  }
}, [additionalFeatureWeight, includeAdditionalFeatures]);

useEffect(() => {
  if (!showFLISection) {
    // setRoiFilterTemp(70);         // Reset to initial ROI value
    // setAppreciationFilterTemp(30); // Reset to initial Appreciation value
        setRoiFilterTemp(INITIAL_ROI);
    setAppreciationFilterTemp(INITIAL_APPRECIATION);
    setIncludeAdditionalFeatures(false); // Optionally disable additional features
    setAdditionalFeatureWeight(20);     // Optionally reset additional feature weight
    setAdditionalFeatureList((prev) =>
      prev.map((f) => ({ ...f, enabled: true, weight: 5 }))
    ); // Optionally reset sub-feature weights and enabled state
  }
}, [showFLISection]);

useEffect(() => {
  if (includeAdditionalFeatures) {
    const enabledFeatures = additionalFeatureList.filter(f => f.enabled);
    const evenWeight = enabledFeatures.length > 0
      ? Math.floor(additionalFeatureWeight / enabledFeatures.length)
      : 0;
    setAdditionalFeatureList(prev =>
      prev.map(f =>
        f.enabled ? { ...f, weight: evenWeight } : f
      )
    );
  }
}, [additionalFeatureWeight, includeAdditionalFeatures]);

useEffect(() => {
  const savedROI = localStorage.getItem("fliROIFilter");
  const savedAppr = localStorage.getItem("fliApprFilter");
  if (savedROI !== null && savedAppr !== null) {
    setFliROIFilter(Number(savedROI));
    setFliApprFilter(Number(savedAppr));
    setRoiFilterTemp(Number(savedROI));
    setAppreciationFilterTemp(Number(savedAppr));
  }
}, []);

  // useEffect(() => {
  //   const handleCopyPaste = (e) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener('copy', handleCopyPaste);
  //   document.addEventListener('cut', handleCopyPaste);
  //   document.addEventListener('paste', handleCopyPaste);
  //   document.addEventListener('contextmenu', handleCopyPaste); // right-click
  //   document.addEventListener('keydown', (e) => {
  //     // Disable Ctrl+C, Ctrl+V, Ctrl+X
  //     if ((e.ctrlKey || e.metaKey) && ['c', 'v', 'x'].includes(e.key.toLowerCase())) {
  //       e.preventDefault();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener('copy', handleCopyPaste);
  //     document.removeEventListener('cut', handleCopyPaste);
  //     document.removeEventListener('paste', handleCopyPaste);
  //     document.removeEventListener('contextmenu', handleCopyPaste);
  //   };
  // }, []);

  // const setMapData = (mapInstance, properties,) => {
  //     if (!mapInstance || !styleLoaded) {
  //         console.log('Map instance or style is not loaded yet');
  //         return;
  //     }

  //     // Remove existing layers and sources if they exist
  //     if (mapInstance.getLayer('collisions')) {
  //         mapInstance.removeLayer('collisions');
  //     }
  //     if (mapInstance.getLayer('roi-labels')) {
  //         mapInstance.removeLayer('roi-labels');
  //     }
  //     if (mapInstance.getSource('collisions')) {
  //         mapInstance.removeSource('collisions');
  //     }
  //     mapInstance.addSource('collisions', {
  //         type: 'geojson',
  //         data: {
  //             type: 'FeatureCollection',
  //             features: properties.map((property) => ({
  //                 type: 'Feature',
  //                 geometry: {
  //                     type: 'Point',
  //                     coordinates: [property.longitude, property.latitude],
  //                 },
  //                 properties: {
  //                     zipcode: property.zipcode,
  //                     roi: property.roi,
  //                     bedrooms: property.bedrooms,
  //                     appreciation: property.appreciation,
  //                     score: property.score,
  //                     rent: property.rent,
  //                     state: property.state,
  //                     city: property.city,
  //                 },
  //             })),
  //         },
  //     });

  //     // Add the 'collisions' layer
  //     mapInstance.addLayer({
  //         id: 'collisions',
  //         type: 'circle',
  //         source: 'collisions',
  //         paint: {
  //             'circle-radius': [
  //                 'interpolate',
  //                 ['linear'],
  //                 ['zoom'],
  //                 0, 3,
  //                 4, 10,
  //                 6, 16,
  //                 8, 20,
  //                 10, 24,
  //             ],
  //             'circle-color': [
  //                 'step',
  //                 ['get', activeMetric],
  //                 '#acacac',
  //                 0, 'red',
  //                 5, '#FFE36B',
  //                 10, '#FFB36B',
  //                 15, '#FE5C5C',
  //                 20, '#F26BFF',
  //                 25, '#CE1E50',
  //             ],
  //         },
  //     layout: {
  //       // This is the key part
  //       'circle-sort-key': ['get', 'roi'], // Higher ROI = drawn later = on top
  //     }
  //     });

  //     // Add the 'roi-labels' layer (labels showing active metric)
  //     mapInstance.addLayer({
  //         id: 'roi-labels',
  //         type: 'symbol',
  //         source: 'collisions',
  //          minzoom: 4, // Labels will appear at zoom level 4 and above
  //         layout: {
  //             'text-field': ['get', activeMetric],
  //             'text-size': 10,
  //             'text-allow-overlap': false, // <- this allows overlapping text
  //         },
  //         paint: {
  //             'text-color': [
  //                 'step',
  //                 ['number', ['get', activeMetric]],
  //                 '#000000',
  //                 10, '#000000',
  //                 15, '#000000',
  //                 20, '#000000',
  //                 25, '#000000',
  //             ],

  //         },
  //     });
  // };

  const setMapData = (mapInstance, properties) => {
    if (!mapInstance || !styleLoaded) {
      console.log("Map instance or style is not loaded yet");
      return;
    }

    // Remove existing layers and sources if they exist
    if (mapInstance.getLayer("collisions")) {
      mapInstance.removeLayer("collisions");
    }
    if (mapInstance.getLayer("roi-labels1")) {
      mapInstance.removeLayer("roi-labels1");
    }
    if (mapInstance.getSource("collisions")) {
      mapInstance.removeSource("collisions");
    }

    //console.log("enter setMapData");
    //console.log("mapInstance", mapInstance);
    console.log("properties in setMapData", properties);

    // Add the source for collisions (properties)
    mapInstance.addSource("collisions", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: properties.map((property) => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [property.longitude, property.latitude],
          },
          properties: {
            zipcode: property.zipcode,
            roi: property.roi,
            bedrooms: property.bedrooms,
            appreciation: property.appreciation,
            score: property.score,
            rent: property.rent,
            state: property.state,
            city: property.city,
          },
        })),
      },
    });

    const appreciationColors = [
      "step",
      ["get", "appreciation"],
      "#acacac",
      0,
      "#FFE36B",
      5,
      "#FFB36B",
      10,
      "#FE5C5C",
      15,
      "#F26BFF",
      20,
      "#CE1E50",
    ];

    const defaultColors = [
      "step",
      ["get", activeMetric],
      "#acacac",
      0,
      "#acacac",
      5,
      "#FFE36B",
      10,
      "#FFB36B",
      15,
      "#FE5C5C",
      20,
      "#F26BFF",
      25,
      "#CE1E50",
    ];

    // Add the 'collisions' layer
    mapInstance.addLayer({
      id: "collisions",
      type: "circle",
      source: "collisions",
      paint: {
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          0,
          3,
          4,
          10,
          6,
          16,
          8,
          20,
          10,
          24,
        ],
        // 'circle-color': [
        //     'step',
        //     ['get', activeMetric],
        //     '#acacac',
        //     0, '#acacac',
        //     5, '#FFE36B',
        //     10, '#FFB36B',
        //     15, '#FE5C5C',
        //     20, '#F26BFF',
        //     25, '#CE1E50',
        // ],

        "circle-color":
          activeMetric === "appreciation" ? appreciationColors : defaultColors,

        //         'circle-stroke-color': '#000000',   // Black border
        // 'circle-stroke-width': 1.5,         // Border width
        // 'circle-stroke-opacity': 0.8,       // Optional: opacity
      },
    });

    // Add the 'roi-labels' layer (labels showing active metric)
    mapInstance.addLayer({
      id: "roi-labels",
      type: "symbol",
      source: "collisions",
      minzoom: 4, // Labels will appear at zoom level 4 and above
      layout: {
        "text-field": ["get", activeMetric],
        "text-size": 10,
        "text-allow-overlap": false, // <- this allows overlapping text
      },
      paint: {
        "text-color": [
          "step",
          ["number", ["get", activeMetric]],
          "#000000",
          10,
          "#000000",
          15,
          "#000000",
          20,
          "#000000",
          25,
          "#000000",
        ],
      },
    });
    // Set visibility of roi-labels layer based on zoom level
    // mapInstance.on('zoom', function() {
    //     var zoomLevel = mapInstance.getZoom();
    //     console.log('zoomlevel',zoomLevel)
    //     if (zoomLevel >= 4) {
    //         mapInstance.setLayoutProperty('roi-labels', 'visibility', 'visible');
    //     } else {
    //         mapInstance.setLayoutProperty('roi-labels', 'visibility', 'none');
    //     }
    // });
    // marker click
    map.on("click", "collisions", clickHandler);
  };
  // Define the clickHandler function outside useEffect
  const clickHandler = (e) => {
    const feature = e.features && e.features[0];
    if (!feature) return; // Exit if no feature was clicked

    const { zipcode, roi, score, appreciation, city, state } =
      feature.properties;
    const coordinates = feature.geometry.coordinates;

    // Remove the previous popup if it exists
    if (popupRef.current) {
      popupRef.current.remove();
      popupRef.current = null;
    }

    // Create new popup content
    const popupContent = `
          <div class="tooltipOuter">
              <div class="tooltipTitle"><span>${zipcode}</span><span class="grey">${city}, ${state}</span></div>
              <div class="tooltipContentOuter">
                  <div class="tooltipContent">
                      <div class="tooltipValues"><span><strong>ROI</strong></span> <span>${roi}%</span></div>
                      <div class="tooltipValues"><span><strong>Appreciation</strong></span> <span>${appreciation}%</span></div>
                      <div class="tooltipValues"><span><strong>FLI</strong></span> <span>${score}</span></div>
                      
                  </div>
                  <div class="tooltipViewBtn">
                      <button id="viewMoreBtn">
                          <span>Explore</span> <img src="/assets/arw-grey.svg" alt="FlowLogic Icon" />
                      </button>
                  </div>
              </div>
          </div>
      `;

    //  Create and store the new popup in a ref (prevents re-renders)
    const newPopup = new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: true,
    })
      .setLngLat(coordinates)
      .setHTML(popupContent)
      .addTo(map);

    popupRef.current = newPopup; // Store popup in ref to prevent duplicates

    // Attach "View More" button event AFTER rendering
    setTimeout(() => {
      const viewMoreBtn = document.getElementById("viewMoreBtn");
      if (viewMoreBtn) {
        viewMoreBtn.onclick = () =>
          handleLocationSelect(zipcode, map, setCurrentPopup);
      }
    }, 100);
  };

  useEffect(() => {
    if (map) {
      // If a MetricToggleButton control exists, remove it
      if (metricControl) {
        map.removeControl(metricControl);
      }
      if (legendControl) {
        map.removeControl(legendControl);
      }
      // Create and add the new MetricToggleButton control
      const newToggleButtonControl = new MetricToggleButton(
        setActiveMetric,
        activeMetric
      );
      map.addControl(newToggleButtonControl, "top");

      // Update the button text when activeMetric changes
      newToggleButtonControl.updateButtonText(activeMetric);

      // Store the new control instance to track it for future updates
      setMetricControl(newToggleButtonControl);

      updateCircleColor(activeMetric);

      // const control = new ColorPalette1(isFullWidth, setIsFullWidth);
      const legendcontrol = new ColorPalette1();
      // Add the control to the map
      map.addControl(legendcontrol, "bottom-left");

      // Store the new control instance to track it for future updates
      setLegendControl(legendcontrol);
    }
  }, [activeMetric, map]); // Re-run this effect when activeMetric changes

  class MetricToggleButton {
    constructor(setActiveMetric, activeMetric) {
      this.container = document.createElement("div");
      this.container.className = "mapboxgl-ctrl mapboxgl-ctrl-top";

      // Styling for the container
      Object.assign(this.container.style, {
        position: "absolute",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)", // Center horizontally
        zIndex: "10",
        backgroundColor: "#00000061",
        padding: "5px 10px",
        borderRadius: "30px",
        display: "flex",
        gap: "10px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.3)", // Adds a slight shadow
        fontSize: "12px",
      });

      // ROI Button
      this.roiButton = document.createElement("button");
      this.roiButton.textContent = "ROI";
      this.roiButton.onclick = () => setActiveMetric("roi");
      this.styleButton(this.roiButton, activeMetric === "roi");

      // Appreciation Button
      this.appreciationButton = document.createElement("button");
      this.appreciationButton.textContent = "Appreciation";
      this.appreciationButton.onclick = () => setActiveMetric("appreciation");
      this.styleButton(
        this.appreciationButton,
        activeMetric === "appreciation"
      );

      // Score Button
      this.scoreButton = document.createElement("button");
      this.scoreButton.textContent = "FLI";
      this.scoreButton.onclick = () => setActiveMetric("score");
      this.styleButton(this.scoreButton, activeMetric === "score");

      // Append buttons to container
      this.container.appendChild(this.roiButton);
      this.container.appendChild(this.appreciationButton);
      this.container.appendChild(this.scoreButton);
    }

    // Apply styles to buttons and highlight the active one
    styleButton(button, isActive) {
      Object.assign(button.style, {
        padding: "8px 15px",
        border: "none",
        borderRadius: "20px",
        cursor: "pointer",
        fontWeight: "bold",
        background: isActive ? "#ffffff" : "none",
        color: isActive ? "black" : "white",
      });
    }

    // When control is added to the map
    onAdd(map) {
      return this.container;
    }

    // When control is removed
    onRemove() {
      this.container.parentNode.removeChild(this.container);
    }

    // Update button styles when metric changes
    updateButtonText(activeMetric) {
      this.styleButton(this.roiButton, activeMetric === "roi");
      this.styleButton(
        this.appreciationButton,
        activeMetric === "appreciation"
      );
      this.styleButton(this.scoreButton, activeMetric === "score");
    }
  }

  class ColorPalette1 {
    constructor() {
      this.container = document.createElement("div");
      this.container.className =
        "mapboxgl-ctrl mapboxgl-ctrl-group color-palatte-outer";
      this.container.style.bottom = "10px";
      this.container.style.left = "10px";
      this.updateContent();
    }

    updateContent() {
      this.container.innerHTML = "";
      const colorLegendContainer = document.createElement("div");
      colorLegendContainer.style.display = "flex";

      roiColors[activeMetric].map((item) => {
        const colorBlock = document.createElement("div");
        colorBlock.className = "color-palatte-single";
        colorBlock.style.backgroundColor = item.color;

        const label = document.createElement("div");
        //label.textContent = item.label + '+';
        label.textContent =
          item.label === "All" ? item.label : `${item.label}+`;

        colorBlock.appendChild(label);

        colorBlock.addEventListener("click", () => {
          console.log("selected lable", item.label);
          if (activeMetric == "roi") {
            setRoiFilter(parseInt(item.label, 10));
            setAppreciationFilter("All");
            setScoreFilter("All");
          } else if (activeMetric == "appreciation") {
            //setAppreciationFilter(parseInt(item.label, 10));
            setAppreciationFilter(
              item.label === "All" ? "All" : parseInt(item.label, 10)
            );
            setRoiFilter("All");
            setScoreFilter("All");
          } else if (activeMetric == "score") {
            setScoreFilter(parseInt(item.label, 10));
            setRoiFilter("All");
            setAppreciationFilter("All");
          }
        });
        colorLegendContainer.appendChild(colorBlock);
      });

      this.container.appendChild(colorLegendContainer);
    }

    onAdd() {
      return this.container;
    }

    onRemove() {
      this.container.parentNode.removeChild(this.container);
    }
  }
  useEffect(() => {
    const accepted = localStorage.getItem("eula_accepted") == "true"; // Check if EULA is accepted
    console.log("EULA Accepted:", accepted);
    console.log(localStorage.getItem("eula_accepted"));
    if (!accepted) {
      //   setShowPdfModal(true);
      setShowEulaModal(true);
    }
  }, []);

  // Load EULA HTML from assets
  useEffect(() => {
    fetch("/assets/eula.html")
      .then((res) => res.text())
      .then((data) => setHtmlContent(data))
      .catch((err) => console.error("Error loading EULA:", err));
  }, []);
  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setCanAccept(true);
      }
    }
  };

  useEffect(() => {
    const checkTokenValidity = () => {
      if (!authToken) {
        navigate("/");
        return;
      }

      try {
        const decoded = jwtDecode(authToken);

        const isExpired = decoded.exp * 1000 < Date.now();

        if (isExpired) {
          // Optional: clear storage
          localStorage.removeItem("authToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("email");
          localStorage.removeItem("isSubscribed");

          navigate("/");
        }
      } catch (e) {
        // If token is malformed or can't be decoded
        localStorage.removeItem("authToken");
        navigate("/");
      }
    };

    checkTokenValidity();
  }, [authToken, navigate]);

  const updateFilter = (stateName = "") => {
    console.log("Enter updateFilter", stateName);
    if (!styleLoaded || !map) {
      console.log("Map style is not loaded yet");
      return;
    }

    // setPopupInstance(null);
    // if (popupInstance) {
    //     popupInstance.remove(); // Remove the previous popup
    //     setPopupInstance(null);
    //     console.log("after drag small popup",popupInstance);
    // }
    // Ensure originalPropertyList is available
    if (originalPropertyList && originalPropertyList.length > 0) {
      // Function to filter properties by current map bounds and active metric filter
      if (!map || !styleLoaded) {
        console.log("Map instance or style is not loaded yet");
        return;
      }

      // console.log("originalPropertyList", originalPropertyList);

      const filterProperties = () => {
        // Get current map bounds
        const bounds = map.getBounds();
        const sw = bounds.getSouthWest();
        const ne = bounds.getNorthEast();
       
        // const filteredByTab =
        //   activeTab === "favorites"
        //     ? originalPropertyList.filter((property) => property.favorite) // Only favorites
        //     : originalPropertyList; // All properties
console.log('fav prp in update filter',favoritePropertyList);
        const filteredByTab =
          activeTab === "favorites"
                      ?favoritePropertyList
            : originalPropertyList;

        console.log("originalPropertyList  inside *** ", originalPropertyList);
        // If in favorites tab, return all favorites without bounds filtering
        // let filteredProperties;
        // if (activeTab === "favorites") {
        //   filteredProperties = [...originalPropertyList];
        // } else {
          // filteredProperties = originalPropertyList.filter((property) => {
            const filteredProperties = filteredByTab.filter((property) => {
            const lat = parseFloat(property.latitude);
            const lng = parseFloat(property.longitude);
            const propertyZipcode = property.zipcode;
            //console.log("lat",lat);
            //console.log("property",property);

            // console.log("originalPropertyList", originalPropertyList);

            // Ensure valid coordinates
            if (isNaN(lat) || isNaN(lng)) return false;

            // If no zipcode filter, apply map bounds and ROI filter
            // const isWithinBounds = lat >= sw.lat && lat <= ne.lat && lng >= sw.lng && lng <= ne.lng;

            // Apply map bounds only if NOT in favorites tab
            const isWithinBounds =
              activeTab === "favorites"
                ? true
                : lat >= sw.lat &&
                  lat <= ne.lat &&
                  lng >= sw.lng &&
                  lng <= ne.lng;

            // Apply ROI, Appreciation, and Score filters

            const meetsROIFilter =
              roiFilter === "All" || property.roi >= roiFilter;
            //const meetsAppreciationFilter = appreciationFilter ? property.appreciation >= appreciationFilter : true;
            const meetsAppreciationFilter =
              appreciationFilter === "All" ||
              property.appreciation >= appreciationFilter;
            //const meetsScoreFilter = scoreFilter ? property.score >= scoreFilter : true;
           // Recalculate score based on crime index before filtering
            let adjustedScore = property.score;
            if(scoreFilter === "All"){

              const roi_percentage = fliROIFilter/100;
              const appr_percentage =fliApprFilter/100;
              property.score =  Math.round(
                                  (parseFloat(property.rawroi) * roi_percentage) +
                                  (parseFloat(property.rawappreciation) * appr_percentage)
                                );

// // Generate random values for each sub-feature (for demo)
// const randomCrimeIndex = Math.random() * 10; // Example: 0-10
// const randomClimaticDistress = Math.random() * 10;
// const randomEmployability = Math.random() * 10;
// const randomEducation = Math.random() * 10;

// // Calculate additional features contribution
// let additionalFeaturesScore = 0;
// if (includeAdditionalFeatures && additionalFeatureWeight > 0) {
//   // Only enabled features
//   const enabledFeatures = additionalFeatureList.filter(f => f.enabled);
//   const totalSubWeight = enabledFeatures.reduce((sum, f) => sum + f.weight, 0) || 1;
//   enabledFeatures.forEach((feature) => {
//     let featureValue = 0;
//     // Use random values for demo
//     if (feature.key === "crimeIndex") featureValue = randomCrimeIndex;
//     if (feature.key === "climaticDistress") featureValue = randomClimaticDistress;
//     if (feature.key === "employability") featureValue = randomEmployability;
//     if (feature.key === "education") featureValue = randomEducation;

//     const featureWeight = (feature.weight / totalSubWeight) * additionalFeatureWeight;
//     if (feature.type === "negative") {
//       additionalFeaturesScore -= featureValue * (featureWeight / 100);
//     } else {
//       additionalFeaturesScore += featureValue * (featureWeight / 100);
//     }
//   });
// }

// property.score = Math.round(
//   (parseFloat(property.rawroi) * roi_percentage) +
//   (parseFloat(property.rawappreciation) * appr_percentage) +
//   additionalFeaturesScore
// );

              // if (crimeIndexFilter && crimeIndexFilter !== " ") {
              //   // Example formula: lower crime index increases score
              //   adjustedScore = property.score +  parseFloat(crimeIndexFilter);

              //   // Update property in-memory (doesn't mutate original list permanently)
              //   property.score = adjustedScore;
                
              // } else {
              //   property.score = property.score;
              // }
            }
            
            const meetsScoreFilter =
              scoreFilter === "All" || property.score >= scoreFilter;

            const meetsSalesFilter =
              property.sales >= minSales && property.sales <= maxSales;

            // return isWithinBounds && meetsROIFilter;
            return (
              isWithinBounds &&
              meetsROIFilter &&
              meetsAppreciationFilter &&
              meetsScoreFilter &&
              meetsSalesFilter
            );
          });
        // }

        return filteredProperties;
      };

      // Get the filtered properties based on the bounds and active filter
      const filteredProperties = filterProperties();

      // console.log('Filtered Property List:', filteredProperties);

      // Sort the filtered properties
      console.log("sortKey", sortKey);
      console.log("sortOrder", sortOrder);  
      console.log("filteredProperties**** bfr srt ", filteredProperties);  
      const sortedProperties = sortProperties(
        filteredProperties,
        sortKey,
        sortOrder
      );
      // Update the propertyList state with filtered properties
      //setPropertyList(filteredProperties);
      setPropertyList(sortedProperties);
      setIsLoading(false);
      // Remove existing layers and sources if they exist
      if (map.getLayer("collisions")) {
        map.removeLayer("collisions");
      }
      if (map.getLayer("roi-labels")) {
        map.removeLayer("roi-labels");
      }
      if (map.getSource("collisions")) {
        map.removeSource("collisions");
      }

      // Reuse setMapData to update the map with filtered properties
      setMapData(map, sortByROI(filteredProperties)); // Update map with filtered properties
    } else {
      console.log("No properties available to filter.");
    }
  };

  // Update filters based on user selection
  const handleSliderChange = (newValue, filterType) => {
    if (filterType === "roi") {
      setRoiFilter(newValue);
    } else if (filterType === "appreciation") {
      //alert(newValue);
      setAppreciationFilter(newValue);
    } else if (filterType === "score") {
      setScoreFilter(newValue);
    }
  };

  const handlePriceSliderChange = (values) => {
    setMinSales(values[0]); // Update the minimum value
    setMaxSales(values[1]); // Update the maximum value
  };
  function formatNumber(num) {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M"; // For millions
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K"; // For thousands
    } else {
      return num; // No change if it's less than 1000
    }
  }

  useEffect(() => {
    if (map) {
      console.log("Enter map");
      // Bind to map movement (zoom or pan)
      map.on("moveend", () => {
        console.log("movened");
        //updateFilter(); // Filter properties based on the current map bounds
      });

      // Bind to zoom events (optional, but useful for map interaction)
      // map.on('zoomend', () => {
      //     console.log("movenzoomed");
      //     updateFilter(); // Reapply filters after zoom
      // });

      // Call updateFilter initially to apply filter based on the initial map state
      updateFilter();
    }
  }, [
    activeTab,
    roiFilter,
    appreciationFilter,
    scoreFilter,
    activeMetric,
    originalPropertyList,
    searchPincode,
    minSales,
    maxSales,
    applyClicked,
    // crimeIndexFilter,
    fliROIFilter,
    // additionalFeatureList,    
    // additionalFeatureWeight  
 
  ]);

  const handleTabChange = (tab) => {
    console.log("Tab clicked:", tab);

    //  // Set loading to true before filtering
    if (activeTab === tab) {
      console.log("same tab");
      setForceRerender((prev) => !prev); // Toggle forceRerender to force update
      updateFilter();
    } else {
      setActiveTab(tab); // Set active tab only if it's different
    }
    setIsLoading(true);
    setCurrentStateId(null);
    setCurrentCity(null);
    // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
    const input = document.querySelector(".mapboxgl-ctrl-geocoder--input");
    if (input) {
      input.value = "";
    }

    // REMOVE EXISTING LAYERS AND SOURCES SAFELY
    if (map.getLayer("state-boundary")) {
      map.removeLayer("state-boundary");
    }
    if (map.getLayer("highlighted-region")) {
      map.removeLayer("highlighted-region");
    }
    if (map.getSource("state-boundary")) {
      map.removeSource("state-boundary");
    }
    if (currentView === "list") {
      setPopupHTML(null);
      setSelectedZipcode(null);
      document.getElementById("detailed_popup").style.display = "none";
    }
    //if (tab === "favorites") {
    // Resize the map before updating the filter

    map.flyTo({
      center: isSubscribed ? [-95.7129, 37.0902] : [-86.2583, 39.8494],
      zoom: isSubscribed ? 3.5 : 9,
      essential: true, // Ensures the animation is not interrupted by user interactions
    });
    //}
  };

  // Load once on component mount
  useEffect(() => {
    const loadGeo = async () => {
      const res = await fetch("/assets/usa.geojson");
      const data = await res.json();
      setUsaGeoJson(data);
    };
    loadGeo();
  }, []);

  function closePopup() {
    if (currentPopup) {
      currentPopup.remove();
      setCurrentPopup(null); // Clear the reference // Clear the reference
    }
  }
  // Attach the function to the window object
  window.closePopup = closePopup;

  function updatePopupHeartIcon(isFav) {
    const favBtn = document.getElementById("favorite-button");
    if (favBtn) {
      favBtn.classList.toggle("highlighted", isFav);
      favBtn.innerHTML = isFav
        ? `<img src="/assets/favorites-fill.svg" alt="Favorite" />`
        : `<img src="/assets/favorites.svg" alt="Not Favorite" />`;
    }
  }
  // Run once on mount
useEffect(() => {
  setUpdatedFavoritePropertyList(favoritePropertyList);
}, []);
useEffect(() => {
  console.log("new fav zipcoed in useeffect",favoriteZipcodes)
  // const updatedFavorites = originalPropertyList.filter((p) =>
  //   favoriteZipcodes.includes(p.zipcode)
  // );
  // setFavoritePropertyList(updatedFavorites);
    setUpdatedFavoritePropertyList(favoritePropertyList);
     console.log("ns etUpdatedFavoritePropertyList",favoritePropertyList)
     
}, [favoriteZipcodes]);
  function toggleFavorite(zipcode, currentFav) {
    console.log("cur and ",currentFav);
    console.log("zipcoder and ",zipcode);
    // Optimistically update UI
    setOriginalPropertyList((prevList) =>
      prevList.map((property) =>
        property.zipcode === zipcode
          ? { ...property, favorite: !property.favorite }
          : property
      )
    );
    setFavoriteZipcodes((prev) => {
  const updated = currentFav
    ? prev.filter((zip) => zip !== zipcode)
    : [...prev, zipcode];

  console.log("Updated Zipcodes:", updated); // ✅ Use this, not favoriteZipcodes directly
  return updated;
});
   

  
    setFavoritePropertyList((prevList) => {
   if (currentFav) {
    // Remove from favorites
    return prevList.filter((property) => property.zipcode !== zipcode);
  } else {
    // Find the full property from the original list
    const fullProperty = originalPropertyList.find(
      (property) => property.zipcode === zipcode
    );

    // // If found and not already in favorites, add it with favorite: true
    // if (fullProperty && !prevList.some((p) => p.zipcode === zipcode)) {
    //   return [
    //     ...prevList,
    //     {
    //       ...fullProperty,
    //       favorite: true, // Add favorite flag here
    //     },
    //   ];
    // }


    if (fullProperty && !prevList.some((p) => p.zipcode === zipcode)) {
      // Normalize fields (fill undefined or missing with defaults)
      const normalizedProperty = {
        zipcode: fullProperty.zipcode || "",
        roi: fullProperty.roi || 0,
        bedrooms: fullProperty.bedrooms ?? 0, // If undefined, set to 0
        state: fullProperty.state || "",
        rent: fullProperty.rent || 0,
        city: fullProperty.city || "",
        score: fullProperty.score || 0,
        sales: fullProperty.sales || 0,
        appreciation: fullProperty.appreciation || 0,
        latitude: fullProperty.latitude || 0,
        longitude: fullProperty.longitude || 0,
        favorite: true,
      };

      return [...prevList, normalizedProperty];
    }

    // Else, return unchanged
    return prevList;
  }
  });
  // setUpdatedFavoritePropertyList(favoritePropertyList);
    console.log("setFavoritePropertyList",favoritePropertyList)
    updatePopupHeartIcon(!currentFav);
if(activeTab=='favorites' &&  currentView=='list'&&  currentFav){
 
  setPopupHTML(null);
  document.getElementById("detailed_popup").style.display = "none";
}

    // API call
    const url = currentFav
      ? `https://beta.flowlogic.com/zip/favorite/remove/`
      : `https://beta.flowlogic.com/zip/favorite/add/`;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ zipcode }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.data) {
          // Rollback UI if failed
          setOriginalPropertyList((prevList) =>
            prevList.map((property) =>
              property.zipcode === zipcode
                ? { ...property, favorite: currentFav }
                : property
            )
          );
          setFavoriteZipcodes((prev) =>
            currentFav
              ? [...prev, zipcode]
              : prev.filter((zip) => zip !== zipcode)
          );
               
   
          updatePopupHeartIcon(currentFav);
          toast.error("Failed to toggle favorite");
        } else {
          if (currentFav) {
            toast.error("Removed from favorites");
          } else {
            toast.success("Added to favorites");
          }
        }
      })
      .catch((error) => {
        // Rollback UI on error
        setOriginalPropertyList((prevList) =>
          prevList.map((property) =>
            property.zipcode === zipcode
              ? { ...property, favorite: currentFav }
              : property
          )
        );
        setFavoriteZipcodes((prev) =>
          currentFav
            ? [...prev, zipcode]
            : prev.filter((zip) => zip !== zipcode)
        );
       
        updatePopupHeartIcon(currentFav);
        toast.error("Network error");
      });
  }
  const transformToGeoJSON = (apiResponse) => {
    return {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [apiResponse.coordinates],
          },
          properties: {
            postcode: apiResponse.postcode,
          },
        },
      ],
    };
  };

  const fetchStateBoundary = async (location) => {
    try {
      // Check if the location is a zip code (numeric check)
      const isZipCode = /^\d+$/.test(location);

      if (isZipCode) {
        // const response = await fetch(`https://beta.flowlogic.com/api/location/${location}/`);
        const response = await fetch(
          `https://beta.flowlogic.com/api/location/${location}/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authToken}`, // Make sure authToken is defined
              "Content-Type": "application/json",
            },
          }
        );
        console.log(`https://beta.flowlogic.com/api/location/${location}/`);

        if (!response.ok) {
          throw new Error(
            `Failed to fetch zip code boundary, status: ${response.status}`
          );
        }

        const apiResponse = await response.json();
        console.log("API Response:", apiResponse);

        const boundaryGeoJSON = transformToGeoJSON(apiResponse);
        console.log("Transformed GeoJSON:", boundaryGeoJSON);

        setCurrentStateId(null);
        setCurrentCity(null);
        return boundaryGeoJSON;
      } else {
        // Fetch boundary for state from the GeoJSON file
        const response = await fetch("/assets/usa.geojson"); // Path to your GeoJSON file

        if (!response.ok) {
          throw new Error(
            `Failed to fetch state boundary, status: ${response.status}`
          );
        }

        const boundaryGeoJSON = await response.json();

        // Find the state's boundary in the GeoJSON
        const stateBoundary = boundaryGeoJSON.features.find(
          (feature) =>
            feature.properties.name.toLowerCase() === location.toLowerCase()
        );

        if (stateBoundary) {
          setCurrentCity(null);
          setCurrentStateId(stateBoundary.id); // Save the state ID for later use
          console.log("state Id", currentStateId);
          return stateBoundary; // Return state boundary
        } else {
          // throw new Error(`Boundary for ${location} not found`);
          setCurrentStateId(null);
          setCurrentCity(location);
        }
      }
    } catch (error) {
      console.error("Error fetching boundary:", error);
      return null;
    }
  };

  class CustomPopupControl {
    constructor(htmlContent) {
      this._htmlContent = htmlContent;
    }

    onAdd() {
      this._container = document.createElement("div");
      this._container.className = "mapboxgl-ctrl custom-popup-control";

      // Set the inner HTML to the provided content
      this._container.innerHTML = this._htmlContent;

      // Store the container in the state (assumed `setCurrentPopup` is a setter for global state)
      setCurrentPopup(this._container); // Store in state
      console.log("popup created", currentPopup);
      // Call this function when initializing the popup
      // updateHeartIcon();  // Initial state of the heart based on `isFavorite`
      return this._container;
    }

    onRemove() {
      // Ensure that the container is still part of the DOM before attempting to remove it
      if (this._container && this._container.parentNode) {
        this._container.parentNode.removeChild(this._container);
      } else {
        console.warn("Popup control already removed or not yet added to DOM.");
      }

      this._map = undefined; // Clean up the map reference
    }
  }

  const handleLocationSelect = (
    location,
    map = "",
    setCurrentPopup,
    currentView = "split"
  ) => {
    if (!map) {
      console.error("Map is not initialized yet!");
      //return;
    }

    //
    setPopupData(null);
           if (currentPopup) {
        currentPopup.remove(); // Close the previous popup
      }

    if (popupRef.current) {
      console.log("popup removed");
      popupRef.current.remove(); // Ensure popup is removed when unmounting
      popupRef.current = null;
    }

    //setCurrentPopup(null);
    console.log("Selected Location:", location);
    setSearchPincode(location); // Set search value

    // Remove existing custom popup control before adding a new one
    if (customPopupRef.current) {
      map.removeControl(customPopupRef.current);
      customPopupRef.current = null;
    }
    // Fetch the boundary data
    fetchStateBoundary(location)
      .then(async (boundaryGeoJSON) => {
        console.log("Fetched Boundary", boundaryGeoJSON);
        try {
          // Ensure map is ready before modifying layers
          if (!map || !map.getStyle()) {
            console.error("Map is not fully loaded yet!");
            return;
          }

          // REMOVE EXISTING LAYERS AND SOURCES SAFELY
          if (map.getLayer("state-boundary")) {
            map.removeLayer("state-boundary");
          }
          if (map.getLayer("highlighted-region")) {
            map.removeLayer("highlighted-region");
          }
          if (map.getSource("state-boundary")) {
            map.removeSource("state-boundary");
          }
          // Add new boundary source
          map.addSource("state-boundary", {
            type: "geojson",
            data: boundaryGeoJSON,
          });

          if (isSubscribed) {
            // Add outline layer
            map.addLayer({
              id: "state-boundary",
              type: "line",
              source: "state-boundary",
              paint: {
                "line-color": "#1C8F7D",
                "line-width": 3,
              },
            });

            // Add fill highlight layer
            map.addLayer({
              id: "highlighted-region",
              type: "fill",
              source: "state-boundary",
              paint: {
                "fill-color": "#BEF2BE",
                "fill-opacity": 0.5,
              },
            });

            // if (
            //   boundaryGeoJSON &&
            //   Array.isArray(boundaryGeoJSON.features) &&
            //   boundaryGeoJSON.features.length > 0 &&
            //   boundaryGeoJSON.features[0].geometry &&
            //   boundaryGeoJSON.features[0].geometry.coordinates &&
            //   boundaryGeoJSON.features[0].geometry.coordinates.length > 0
            // ) {
            //   const bbox = turf.bbox(boundaryGeoJSON);
            //   map.fitBounds(bbox, { padding: 50 });
            // } else {
            //   console.error(
            //     " Invalid or empty boundaryGeoJSON:",
            //     boundaryGeoJSON
            //   );
            // }
            const bbox = turf.bbox(boundaryGeoJSON);
            map.fitBounds(bbox, { padding: 50 });
          }
        } catch (err) {
          console.error("Error while plotting boundary:", err);
          // continue execution anyway
        }

        const isZipCode = /^\d+$/.test(location);

        if (isZipCode) {
          // Close previously opened popup
          console.log("Before closing popup, currentPopup:", currentPopup);
          // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
          const input = document.querySelector(
            ".mapboxgl-ctrl-geocoder--input"
          );
          if (input) {
            input.value = "";
          }

          if (currentPopup) {
            console.log("Closing existing popup");
            currentPopup.remove();
            setCurrentPopup(null); // Reset the currentPopup state
            console.log("Reset popup, currentPopup:", currentPopup);
          }
          console.log("After closing popup, currentPopup:", currentPopup);
          // Fetch Location Details API
          //const response = await fetch(`https://beta.flowlogic.com/api/web-reports/?type=expanded&zipcode=${location}`);
          console.log(
            `https://beta.flowlogic.com/api/web-reports/?type=compact&zipcode=${location}`
          );

          const url = `https://beta.flowlogic.com/api/reports/?type=expanded&zipcode=${location}`;

          const response = await fetch(url, {
            method: "GET", // Assuming GET method for fetching data
            headers: {
              Authorization: `Bearer ${authToken}`, // Pass the authToken as Authorization header
              "Content-Type": "application/json", // Add content type as JSON
            },
          });
          const responseData = await response.json();

          if (!responseData || responseData.results.length === 0) {
            console.error("No response data for location details.");
            return;
          }

          console.log("Location Details Response:", responseData);

          // // Extract center coordinates
          // const centerCoords =
          //   turf.centerOfMass(boundaryGeoJSON).geometry.coordinates;

          // Generate Popup HTML with all bedroom details
          //let popupHTML = `<strong>Zipcode:</strong> ${location} <br/><br/>`;

          // Extract general details from the first result (since all results have the same location details)
          const firstResult = responseData.results[0];
          const pincode = firstResult.zipcode;
          const county = firstResult.county_name;
          const metro = firstResult.metro;
          const city = firstResult.city;
          const state = firstResult.state;
          //const score = firstResult.score;
          const latest_year = firstResult.last_updated_sales_year;

          // ...existing code...
          let popupHTML = `<div class="custom-popup">`;

          // **TOP HEADER SECTION**
          popupHTML += `
                    <div class="popup-header">
                        <div class="popup-header-left">
                        <div class="popup-text">
                            <div class="popup-title">
                                ${pincode} | ${city}
                            </div>
                            <div class="popup-subtitle"> ${county} | (${state})</div>
                        </div>     
                `;

          const roiData = {};
          const crimeScoreData = {};
          const scoreData = {};
          const appreciationData = {};
          const avgSalesData = {};
          const avgMonthlyRentData = {};
          const avgYearlyRentData = {};
          let favourites = 0;
          // Calculate average for each year

          //const salesData = { '2021': [], '2022': [], '2023': [], '2024': [] };

          const salesData = {};
          const averageSales = {};
          // Define offsets for historical sales data fields
          const salesFields = [
            { offset: 3, field: "sales_data_three" },
            { offset: 2, field: "sales_data_two" },
            { offset: 1, field: "sales_data_one" },
            { offset: 0, field: "avg_current_sales" },
          ];

          // Initialize salesData with dynamic year keys
          salesFields.forEach(({ offset }) => {
            const year = (latest_year - offset).toString();
            salesData[year] = [];
          });
          // Group properties by bedrooms
          responseData.results.forEach((property) => {
            const bedrooms = property.bedrooms || "Unknown";

            //      // Store crime_score per bedroom
            //  if (!crimeScoreData[bedrooms]) {
            //     crimeScoreData[bedrooms] = Number(property.crime_score).toFixed(2);
            //     }
            // ✅ DEBUG: Log bedroom and crime score
            console.log(`[DEBUG] Bedrooms: ${bedrooms}`);
            console.log(`[DEBUG] Raw Crime Score:`, property.crime_score);

            // ✅ Store crime_score per bedroom
            if (!crimeScoreData[bedrooms]) {
              const crime = Number(property.crime_score);
              if (!isNaN(crime)) {
                crimeScoreData[bedrooms] = crime.toFixed(2);
                console.log(
                  `[DEBUG] Stored Crime Score for ${bedrooms}BR: ${crimeScoreData[bedrooms]}`
                );
              } else {
                console.warn(
                  `[WARN] Invalid crime_score for ${bedrooms}BR:`,
                  property.crime_score
                );
                crimeScoreData[bedrooms] = "N/A";
              }
            }

            // Populate salesData dynamically
            responseData.results.forEach((property) => {
              salesFields.forEach(({ offset, field }) => {
                const year = (latest_year - offset).toString();
                const value = parseFloat(property[field]);
                console.log(year);
                console.log(value);
                if (!isNaN(value)) {
                  salesData[year].push(value);
                }
              });
            });

            // Calculate average sales for each year
            Object.keys(salesData).forEach((year) => {
              const values = salesData[year];
              const sum = values.reduce((a, b) => a + b, 0);
              averageSales[year] = values.length ? sum / values.length : 0;
            });

            // ROI data
            if (!roiData[bedrooms]) roiData[bedrooms] = [];
            roiData[bedrooms].push(`${property.roi}%`);

            // score data
            if (!scoreData[bedrooms]) scoreData[bedrooms] = [];

            // Ensure score is a valid number before adding
            const score = parseFloat(property.score);
            if (!isNaN(score)) {
              scoreData[bedrooms].push(score);
            }
            // Appreciation data
            if (!appreciationData[bedrooms]) appreciationData[bedrooms] = [];
            appreciationData[bedrooms].push(`${property.appreciation}%`);

            // Avg Sales data
            if (!avgSalesData[bedrooms]) avgSalesData[bedrooms] = 0;
            avgSalesData[bedrooms] += parseFloat(property.avg_current_sales);

            // Avg Monthly data
            if (!avgMonthlyRentData[bedrooms]) avgMonthlyRentData[bedrooms] = 0;
            avgMonthlyRentData[bedrooms] += parseFloat(
              property.avg_monthly_rent
            );

            // Avg Yearly data
            if (!avgYearlyRentData[bedrooms]) avgYearlyRentData[bedrooms] = 0;
            avgYearlyRentData[bedrooms] += parseFloat(property.avg_yearly_rent);

            //favourites
            // favourites = property.is_favorite;
            if (property.is_favorite === true) {
              favourites = 1;
            }
          });
          const firstAvailableCrimeScore =
            Object.values(crimeScoreData)[0] || "N/A";

          const totalScores = Object.values(scoreData)
            .flat()
            .filter((score) => !isNaN(score));
          const avgScore =
            totalScores.length > 0
              ? Math.round(
                  totalScores.reduce((acc, val) => acc + val, 0) /
                    totalScores.length
                )
              : 0; // Default to 0 if no valid scores
          //           if (favourites === 1) {
          //             popupHTML += `
          //                         <a id="favorite-button" class="popup-favorite-button highlighted">
          //                             <img src="/assets/favorites-fill.svg" alt="Favorite" /> <!-- Heart symbol -->
          //                         </a></div>`;
          //             isFavorite = true; // Set isFavorite to true since it's already marked as a favorite
          //           } else {
          //             popupHTML += `
          //                         <a id="favorite-button" class="popup-favorite-button">
          //                             <img src="/assets/favorites.svg" alt="Not Favorite" /> <!-- Heart symbol -->
          //                         </a> </div>`;
          //             isFavorite = false; // Set isFavorite to false
          //           }

          //           popupHTML += `<div class="popup-heading"><div class="popup-subheading"><span>FLI</span>

          //                  <span>${
          //                    avgScore !== undefined ? Number(avgScore).toFixed(2) : ""
          //                  }</span>

          //                  </div></div>`;

          //           // --- Accordion: Chart ---
          //           popupHTML += `
          //   <div class="accordion-item" id="accordion-chart">
          //     <div class="accordion-header"  style="">
          //       <span><h6>Sales Value Chart</h6></span><span  style="color: #3d3d3d;">▼</span>
          //     </div>
          //     <div class="accordion-content" style="display:none; padding:10px; background: #dcedeb;">
          //       <div class="popup-content">
          //         <canvas id="popupChart" width="300" height="150" style="display: ${
          //           currentView !== "list" ? "block" : "none"
          //         };"></canvas>
          //         <canvas id="popupChartList" width="300" height="150" style="display: ${
          //           currentView === "list" ? "block" : "none"
          //         };"></canvas>
          //       </div>
          //     </div>
          //   </div>
          // `;

          //           // --- Accordion: ROI ---
          //           popupHTML += `
          //   <div class="accordion-item" id="accordion-roi">
          //     <div class="accordion-header">
          //       <span><h6>ROI</h6></span><span  style="color: #3d3d3d;">▼</span>
          //     </div>
          //     <div class="accordion-content" style="display:none; padding:10px; background: #dcedeb;">
          //       ${Object.keys(roiData)
          //         .map(
          //           (bedroom) => `
          //         <div class="popup-row">
          //           <span class="popup-left">${bedroom} bd</span>
          //           <span class="popup-right">${roiData[bedroom].join(", ")}</span>
          //         </div>
          //       `
          //         )
          //         .join("")}
          //     </div>
          //   </div>
          // `;

          //           // --- Accordion: Appreciation ---
          //           popupHTML += `
          //   <div class="accordion-item" id="accordion-appreciation">
          //     <div class="accordion-header"  ">
          //       <span><h6>Appreciation</h6></span><span  style="color: #3d3d3d;">▼</span>
          //     </div>
          //     <div class="accordion-content" style="display:none; padding:10px; background: #dcedeb;">
          //       ${Object.keys(appreciationData)
          //         .map(
          //           (bedroom) => `
          //         <div class="popup-row">
          //           <span class="popup-left">${bedroom} bd</span>
          //           <span class="popup-right">${appreciationData[bedroom].join(
          //             ", "
          //           )}</span>
          //         </div>
          //       `
          //         )
          //         .join("")}
          //     </div>
          //   </div>
          // `;

          //           // --- Accordion: Avg Sales Value ---
          //           popupHTML += `
          //   <div class="accordion-item" id="accordion-sales">
          //     <div class="accordion-header">
          //       <span><h6>Avg Sales Value</h6></span><span  style="color: #3d3d3d;">▼</span>
          //     </div>
          //     <div class="accordion-content" style="display:none; padding:10px; background: #dcedeb;">
          //       ${Object.keys(avgSalesData)
          //         .map(
          //           (bedroom) => `
          //         <div class="popup-row">
          //           <span class="popup-left">${bedroom} bd</span>
          //           <span class="popup-right">$${Math.floor(
          //             avgSalesData[bedroom]
          //           ).toLocaleString()}</span>
          //         </div>
          //       `
          //         )
          //         .join("")}
          //     </div>
          //   </div>
          // `;

          //           // --- Accordion: Avg Yearly Rent ---
          //           popupHTML += `
          //   <div class="accordion-item" id="accordion-yearlyrent">
          //     <div class="accordion-header"  >
          //       <span><h6>Avg Yearly Rent</h6></span><span  style="color: #3d3d3d;">▼</span>
          //     </div>
          //     <div class="accordion-content" style="display:none; padding:10px; background: #dcedeb;">
          //       ${Object.keys(avgYearlyRentData)
          //         .map(
          //           (bedroom) => `
          //         <div class="popup-row">
          //           <span class="popup-left">${bedroom} bd</span>
          //           <span class="popup-right">$${avgYearlyRentData[
          //             bedroom
          //           ].toLocaleString()}</span>
          //         </div>
          //       `
          //         )
          //         .join("")}
          //     </div>
          //   </div>
          // `;

          if (favourites === 1) {
            popupHTML += `
                        <a id="favorite-button" class="popup-favorite-button highlighted">
                            <img src="/assets/favorites-fill.svg" alt="Favorite" /> <!-- Heart symbol -->
                        </a>`;
            isFavorite = true; // Set isFavorite to true since it's already marked as a favorite
          } else {
            popupHTML += `
                        <a id="favorite-button" class="popup-favorite-button">
                            <img src="/assets/favorites.svg" alt="Not Favorite" /> <!-- Heart symbol -->
                        </a>`;
            isFavorite = false; // Set isFavorite to false
          }
          popupHTML += ` </div>`; // main header close div
          popupHTML += ` <button class="popup-close-button" onClick="closePopup()">×</button>
                      </div>`;

          //score
          popupHTML += `<div class="popup-heading"><div class="popup-subheading"><span><h6>FLI</h6></span>

                 <span class="fli-index">${
                   avgScore !== undefined ? Math.round(avgScore) : ""
                 }</span>
 
                 </div>

                 
               </div>`;


          // --- Accordion: Chart ---
          popupHTML += `
              <div class="accordion-item expanded" id="accordion-chart">
                <div class="accordion-header">
                  <span><h6>Avg Home Value History</h6></span>
                  <span class="accordion-arrow" style="color:#3d3d3d;">▲</span>
                </div>
                <div class="accordion-content">
                  <div class="popup-content">
                    <canvas id="popupChart" width="300" height="150" style="display: ${
                      currentView !== "list" ? "block" : "none"
                    };"></canvas>
                    <canvas id="popupChartList" width="300" height="150" style="display: ${
                      currentView === "list" ? "block" : "none"
                    };"></canvas>
                  </div>
                </div>
              </div>
            `;
          // --- Accordion: ROI ---

          const allROIValues = Object.values(roiData)
            .flatMap((val) => (Array.isArray(val) ? val : [val])) // flatten and normalize
            .map((val) => {
              // Convert to string, remove %, trim, parse as float
              const cleaned = parseFloat(String(val).replace("%", "").trim());
              return isNaN(cleaned) ? null : cleaned;
            })
            .filter((val) => val !== null); // Remove any NaN or invalid values

          const overallROIAverage = allROIValues.length
            ? (
                allROIValues.reduce((sum, val) => sum + val, 0) /
                allROIValues.length
              ).toFixed(2)
            : "N/A";

          console.log("Overall ROI Average:", overallROIAverage);

          popupHTML += `
  <div class="accordion-item expanded" id="accordion-roi">
    <div class="accordion-header">
      <span><h6>ROI</h6></span>
       <div class="accordion-right-info">
        <span class="accordion-average"  style="display:none;">${overallROIAverage}%</span>
      <span class="accordion-arrow" style="color:#3d3d3d;">▲</span>
      </div>
    </div>
    <div class="accordion-content">
      <div class="accordion-body">
        <div class="accordion-left">
          ${Object.keys(roiData)
            .map((bedroom) => {
              const values = roiData[bedroom];
              const avg = (
                values.reduce((sum, val) => sum + Number(val), 0) /
                values.length
              ).toFixed(1);

              return `
                <div class="popup-row">
                  <span class="popup-left">${bedroom} bd</span>
                  <span class="popup-right">${values.join(", ")} </span>
                </div>
                ${values
                  .map((val) => {
                    const numericVal = Number(String(val).replace("%", ""));
                    return `
                      <div class="progress-bar">
                        <div class="progress-fill-colored" style="width:${numericVal}%;"></div>
                        <div class="progress-fill-remaining" style="width:${
                          100 - numericVal
                        }%;"></div>
                        <span class="progress-label">${numericVal}%</span>
                      </div>
                    `;
                  })
                  .join("")}
              `;
            })
            .join("")}
        </div>

        <!-- Right column just for Avg -->
        <div class="accordion-right">
          <div class="avg-box">
            <span class="avg-value"  style="color:${overallROIAverage < 0 ? 'red' : '#3d3d3d'}">${overallROIAverage}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

          // --- Accordion: Appreciation ---

          const allAppreciationValues = Object.values(appreciationData)
            .flatMap((val) => (Array.isArray(val) ? val : [val])) // flatten and normalize
            .map((val) => {
              // Convert to string, remove %, trim, parse as float
              const cleaned = parseFloat(String(val).replace("%", "").trim());
              return isNaN(cleaned) ? null : cleaned;
            })
            .filter((val) => val !== null); // Remove any NaN or invalid values

          const overallAppreciationAverage = allAppreciationValues.length
            ? (
                allAppreciationValues.reduce((sum, val) => sum + val, 0) /
                allAppreciationValues.length
              ).toFixed(2)
            : "N/A";

          console.log(
            "Overall Appreciation Average:",
            overallAppreciationAverage
          );

          popupHTML += `
  <div class="accordion-item expanded" id="accordion-appreciation">
    <div class="accordion-header">
      <span><h6>Appreciation</h6></span>
        <div class="accordion-right-info">
        <span class="accordion-average"  style="display:none;"> ${overallAppreciationAverage}%</span>
      <span class="accordion-arrow" style="color:#3d3d3d;">▲</span>
        </div>
    </div>
    <div class="accordion-content">
      <div class="accordion-body">
        <div class="accordion-left">
          ${Object.keys(appreciationData)
            .map((bedroom) => {
              const values = appreciationData[bedroom];
              const avg = (
                values.reduce((sum, val) => sum + Number(val), 0) /
                values.length
              ).toFixed(1);

              return `
                <div class="popup-row">
                  <span class="popup-left">${bedroom} bd</span>
                  <span class="popup-right">${values.join(", ")}</span>
                </div>
                ${values
                  .map((val) => {
                    const numericVal = Number(String(val).replace("%", ""));
                    return `
                      <div class="progress-bar">
                        <div class="progress-fill-colored" style="width:${numericVal}%;"></div>
                        <div class="progress-fill-remaining" style="width:${
                          100 - numericVal
                        }%;"></div>
                        <span class="progress-label">${numericVal}%</span>
                      </div>
                    `;
                  })
                  .join("")}
              `;
            })
            .join("")}
        </div>

        <!-- Right column just for Avg -->
        <div class="accordion-right">
          <div class="avg-box">
            <span class="avg-value"  style="color:${overallAppreciationAverage < 0 ? 'red' : '#3d3d3d'}">${overallAppreciationAverage}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

          // --- Calculate Overall Avg Home Value ---
          const allAvgSalesValues = Object.values(avgSalesData)
            .flatMap((val) => (Array.isArray(val) ? val : [val])) // flatten
            .map((val) => parseFloat(val))
            .filter((val) => !isNaN(val)); // clean

          const overallAvgSalesValue = allAvgSalesValues.length
            ? Math.floor(
                allAvgSalesValues.reduce((sum, val) => sum + val, 0) /
                  allAvgSalesValues.length
              )
            : "N/A";

          // --- Accordion: Avg Sales Price (Redesigned like Appreciation) ---
          popupHTML += `
  <div class="accordion-item expanded" id="accordion-sales">
    <div class="accordion-header">
      <span><h6>Avg Home Value</h6></span>
        <div class="accordion-right-info">
      <span class="accordion-average"  style="display:none;"> ${formatCurrency(
        overallAvgSalesValue
      )}</span>
      <span class="accordion-arrow" style="color:#3d3d3d;">▲</span>
       </div>
    </div>
    <div class="accordion-content">
      <div class="accordion-body">
        <div class="accordion-left">
          ${Object.keys(avgSalesData)
            .map((bedroom) => {
              const values = Array.isArray(avgSalesData[bedroom])
                ? avgSalesData[bedroom]
                : [avgSalesData[bedroom]];

              return `
                <div class="popup-row">
                  <span class="popup-left">${bedroom} bd</span>
                  <span class="popup-right">
                    ${values
                      .map((v) => `$${Math.floor(v).toLocaleString()}`)
                      .join(", ")}
                  </span>
                </div>
              `;
            })
            .join("")}
        </div>

        <!-- Right column just for Avg -->
        <div class="accordion-right">
          <div class="avg-box">
            <span class="avg-value">${formatCurrency(
              overallAvgSalesValue
            )}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;
        //crime score
          popupHTML += `<div class="popup-heading"><div class="crime-header"><span><h6>Crime Index</h6></span>

                 <span class="crime-index">${firstAvailableCrimeScore !== undefined
                   ? firstAvailableCrimeScore
                   : ""
                 }</span>
 
                 </div>

               </div>`;

          const customPopupControl = new CustomPopupControl(popupHTML);
          map.addControl(customPopupControl, "top-right");
          customPopupRef.current = customPopupControl; // Store it in ref
          // After injecting popupHTML, add accordion toggle logic:
          // document.querySelectorAll(".accordion-header").forEach((header) => {
          //   header.addEventListener("click", () => {
          //     const item = header.parentElement;
          //     const content = item.querySelector(".accordion-content");
          //     const expanded = content.style.display === "block";
          //     if (expanded) {
          //       content.style.display = "none";
          //       item.style.color = "#3d3d3d";
          //       header.style.borderBottom = "2px solid #ccc";
          //       header.style.color = "#3d3d3d";
          //       header.querySelector("span:last-child").innerText = "▼";
          //     } else {
          //       content.style.display = "block";
          //       item.style.color = "#3d3d3d";
          //       header.style.border = "none";
          //       header.style.backgroundColor = "rgb(220, 237, 235)";
          //       header.querySelector("span:last-child").innerText = "▲";
          //     }
          //   });
          // });

          const favoriteButton = document.getElementById("favorite-button");
          if (favoriteButton) {
            favoriteButton.addEventListener("click", () => {
              // toggleFavorite(pincode); // Use the location (zipcode) passed to the function
              toggleFavorite(pincode, isFavorite);
              updatePopupHeartIcon(!isFavorite); // Instantly update heart icon
              isFavorite = !isFavorite; //
            });
          }

          // ...existing code...

          setTimeout(() => {
            let canvas;
            if (currentView === "list") {
              canvas = document.getElementById("popupChartList");
            } else {
              canvas = document.getElementById("popupChart");
            }
            if (canvas) {
              if (popupChartListRef.current) {
                popupChartListRef.current.destroy();
              }
              const ctx = canvas.getContext("2d");
              //const years = ['2021', '2022', '2023', '2024']; // Years on the X-axis
              const years = Array.from({ length: 4 }, (_, i) =>
                String(latest_year - 3 + i)
              );

              const avgCurrentSales = years.map(
                (year) => averageSales[year] || 0
              );

              popupChartListRef.current = new Chart(ctx, {
                type: "line",
                data: {
                  labels: years, // X-axis labels
                  datasets: [
                    {
                      label: "Avg Home Value",
                      data: avgCurrentSales, // Y-axis data
                      borderColor: "rgba(75, 192, 192, 1)",
                      borderWidth: 2,
                      fill: false,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: { display: true, labels: { boxWidth: 0 } },
                    tooltip: {
                      callbacks: {
                        // Format tooltip to include $ sign and commas for thousands
                        label: function (tooltipItem) {
                          //return '$' + tooltipItem.raw.toLocaleString(); // Formats the tooltip value with $
                          return formatCurrency(tooltipItem.raw);
                        },
                      },
                    },
                  },
                  scales: {
                    x: { title: { display: false, text: "Year" } },
                    y: {
                      //beginAtZero: true,
                      title: { display: false, text: "Value ($)" },
                      ticks: {
                        // Format the y-axis ticks to include $ and commas
                        callback: function (value) {
                          //return '$' + value.toLocaleString(); // Formats Y-axis values with $
                          return formatCurrency(value); // Use the custom formatter
                        },
                      },
                    },
                  },
                },
              });
            } else {
              console.error("Chart canvas not found.");
            }
          }, 100); // Delay of 100ms to ensure canvas is rendered before Chart.js is initialized
        }
      })
      .catch((error) => {
        console.error("Error fetching boundary:", error);
      });
  };

  // Attach listener once, not inside your popup builder
  if (!window.accordionListenerAdded) {
    document.addEventListener("click", function (e) {
      const header = e.target.closest(".accordion-header");
      if (!header) return;

      const item = header.parentElement;
      item.classList.toggle("expanded");

      const content = item.querySelector(".accordion-content");
      if (content) {
        content.style.display = item.classList.contains("expanded")
          ? "block"
          : "none";
      }

      const arrow = header.querySelector(".accordion-arrow");
      if (arrow) {
        arrow.textContent = item.classList.contains("expanded") ? "▲" : "▼";
      }

      // ✅ handle average show/hide
      const avg = header.querySelector(".accordion-average");
      if (avg) {
        avg.style.display = item.classList.contains("expanded")
          ? "none"
          : "inline";
      }
    });

    // mark it as added so we don’t re-bind
    window.accordionListenerAdded = true;
  }

  const handleLocationSelectList = (
    location,
    map = "",
    setCurrentPopup,
    currentView = "split"
  ) => {
    if (!map) {
      console.error("Map is not initialized yet!");
      //return;
    }

    //
    setPopupData(null);
    if (popupRef.current) {
      console.log("popup removed");
      popupRef.current.remove(); // Ensure popup is removed when unmounting
      popupRef.current = null;
    }

    //setCurrentPopup(null);
    console.log("Selected Location:", location);
    setSearchPincode(location); // Set search value

    // Remove existing custom popup control before adding a new one
    if (customPopupRef.current) {
      map.removeControl(customPopupRef.current);
      customPopupRef.current = null;
    }
    // REMOVE EXISTING LAYERS AND SOURCES SAFELY
    if (map.getLayer("state-boundary")) {
      map.removeLayer("state-boundary");
    }
    if (map.getLayer("highlighted-region")) {
      map.removeLayer("highlighted-region");
    }
    if (map.getSource("state-boundary")) {
      map.removeSource("state-boundary");
    }

    // Define the clickHandler function outside useEffect

    // Fetch the boundary data
    fetchStateBoundary(location)
      .then(async (boundaryGeoJSON) => {
        //console.log("Fetched Boundary", boundaryGeoJSON);

        // **Fetch Location Details for Tooltip**
        const isZipCode = /^\d+$/.test(location);

        if (isZipCode) {
          // Close previously opened popup
          // console.log("Before closing popup, currentPopup:", currentPopup);
          // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
          const input = document.querySelector(
            ".mapboxgl-ctrl-geocoder--input"
          );
          if (input) {
            input.value = "";
          }

          if (currentPopup) {
            // console.log("Closing existing popup");
            currentPopup.remove();
            setCurrentPopup(null); // Reset the currentPopup state
            //console.log("Reset popup, currentPopup:", currentPopup);
          }
          //console.log("After closing popup, currentPopup:", currentPopup);
          // Fetch Location Details API
          //const response = await fetch(`https://beta.flowlogic.com/api/web-reports/?type=expanded&zipcode=${location}`);
          //console.log(`https://beta.flowlogic.com/api/web-reports/?type=compact&zipcode=${location}`);

          const url = `https://beta.flowlogic.com/api/reports/?type=expanded&zipcode=${location}`;

          const response = await fetch(url, {
            method: "GET", // Assuming GET method for fetching data
            headers: {
              Authorization: `Bearer ${authToken}`, // Pass the authToken as Authorization header
              "Content-Type": "application/json", // Add content type as JSON
            },
          });
          const responseData = await response.json();

          if (!responseData || responseData.results.length === 0) {
            console.error("No response data for location details.");
            return;
          }

          //console.log("Location Details Response:", responseData);

          // Extract center coordinates
          //const centerCoords = turf.centerOfMass(boundaryGeoJSON).geometry.coordinates;

          // Generate Popup HTML with all bedroom details
          //let popupHTML = `<strong>Zipcode:</strong> ${location} <br/><br/>`;

          // Extract general details from the first result (since all results have the same location details)
          const firstResult = responseData.results[0];
          const pincode = firstResult.zipcode;
          const county = firstResult.county_name;
          const metro = firstResult.metro;
          const city = firstResult.city;
          const state = firstResult.state;
          //const score = firstResult.score;
          let popupHeight = "auto"; // default collapsed
          // ...existing code...

          let popupHTML = `
  <div class="custom-popup-list" style="height: ${popupHeight}; transition: height 0.3s ease; overflow-y: auto; position: relative;">
    <span id="popupToggleArrow"
      style="cursor: pointer; font-size: 20px; position: absolute; top: 10px; right: 50px; z-index: 10;">

     <img src="/assets/arrow-small-up.png" alt="Toggle" style="width: 20px; height: 20px;" />
    </span>
`;

          // TOP HEADER SECTION
          popupHTML += `
  <div class="popup-header">
    <div class="popup-title-wrap">
      <div class="popup-text">
        <div class="popup-title">${pincode} | ${city}</div>
        <div class="popup-subtitle">${county} | (${state})</div>
      </div>`;
          //       ${favourites === 1
          //         ? `<a id="favorite-button" class="popup-favorite-button highlighted">
          //             <img src="/assets/favorites-fill.svg" alt="Favorite" />
          //           </a>`
          //         : `<a id="favorite-button" class="popup-favorite-button">
          //             <img src="/assets/favorites.svg" alt="Not Favorite" />
          //           </a>`
          //       }
          //     </div>
          //     <button class="popup-close-button" id="popup-close-btn">×</button>
          //   </div>
          // `;
          const roiData = {};
          const crimeScoreData = {};
          const scoreData = {};
          const appreciationData = {};
          const avgSalesData = {};
          const avgMonthlyRentData = {};
          const avgYearlyRentData = {};
          let favourites = 0;
          // Calculate average for each year
          const latest_year = firstResult.last_updated_sales_year;

          // Define offsets for historical sales data fields
          const salesFields = [
            { offset: 3, field: "sales_data_three" },
            { offset: 2, field: "sales_data_two" },
            { offset: 1, field: "sales_data_one" },
            { offset: 0, field: "avg_current_sales" },
          ];

          // Initialize structures
          const salesData = {};
          const averageSales = {};

          // Initialize salesData with dynamic year keys
          salesFields.forEach(({ offset }) => {
            const year = (latest_year - offset).toString();
            salesData[year] = [];
          });
          // Group properties by bedrooms
          responseData.results.forEach((property) => {
            const bedrooms = property.bedrooms || "Unknown";

           console.log(`[DEBUG] Bedrooms: ${bedrooms}`);
            console.log(`[DEBUG] Raw Crime Score:`, property.crime_score);

            // ✅ Store crime_score per bedroom
            if (!crimeScoreData[bedrooms]) {
              const crime = Number(property.crime_score);
              if (!isNaN(crime)) {
                crimeScoreData[bedrooms] = crime.toFixed(2);
                console.log(
                  `[DEBUG] Stored Crime Score for ${bedrooms}BR: ${crimeScoreData[bedrooms]}`
                );
              } else {
                console.warn(
                  `[WARN] Invalid crime_score for ${bedrooms}BR:`,
                  property.crime_score
                );
                crimeScoreData[bedrooms] = "N/A";
              }
            }


            responseData.results.forEach((property) => {
              salesFields.forEach(({ offset, field }) => {
                const year = (latest_year - offset).toString();
                const value = parseFloat(property[field]);
                if (!isNaN(value)) {
                  salesData[year].push(value);
                }
              });
            });

            // Calculate average sales for each year
            Object.keys(salesData).forEach((year) => {
              const values = salesData[year];
              const sum = values.reduce((a, b) => a + b, 0);
              averageSales[year] = values.length ? sum / values.length : 0;
            });

            // ROI data
            if (!roiData[bedrooms]) roiData[bedrooms] = [];
            roiData[bedrooms].push(`${Number(property.roi).toFixed(2)}%`);

            // score data
            if (!scoreData[bedrooms]) scoreData[bedrooms] = [];

            // Ensure score is a valid number before adding
            const score = parseFloat(property.score);
            if (!isNaN(score)) {
              scoreData[bedrooms].push(score);
            }
            // Appreciation data
            if (!appreciationData[bedrooms]) appreciationData[bedrooms] = [];
            appreciationData[bedrooms].push(
              `${Number(property.appreciation).toFixed(2)}%`
            );

            // Avg Sales data
            if (!avgSalesData[bedrooms]) avgSalesData[bedrooms] = 0;
            avgSalesData[bedrooms] += parseFloat(property.avg_current_sales);

            // Avg Monthly data
            if (!avgMonthlyRentData[bedrooms]) avgMonthlyRentData[bedrooms] = 0;
            avgMonthlyRentData[bedrooms] += parseFloat(
              property.avg_monthly_rent
            );

            // Avg Yearly data
            if (!avgYearlyRentData[bedrooms]) avgYearlyRentData[bedrooms] = 0;
            avgYearlyRentData[bedrooms] += parseFloat(property.avg_yearly_rent);

            //favourites
            // favourites = property.is_favorite;
            if (property.is_favorite === true) {
              favourites = 1;
            }
          });

          const totalScores = Object.values(scoreData)
            .flat()
            .filter((score) => !isNaN(score));
          const avgScore =
            totalScores.length > 0
              ? Math.round(
                  totalScores.reduce((acc, val) => acc + val, 0) /
                    totalScores.length
                )
              : 0; // Default to 0 if no valid scores

          // <!-- Heart Icon for Favorite -->

          if (favourites === 1) {
            popupHTML += `
                          <a id="favorite-button" class="popup-favorite-button highlighted">
                              <img src="/assets/favorites-fill.svg" alt="Favorite" /> <!-- Heart symbol -->
                          </a>`;
            isFavorite = true; // Set isFavorite to true since it's already marked as a favorite
          } else {
            popupHTML += `
                          <a id="favorite-button" class="popup-favorite-button">
                              <img src="/assets/favorites.svg" alt="Not Favorite" /> <!-- Heart symbol -->
                          </a>`;
            isFavorite = false; // Set isFavorite to false
          }
          popupHTML += `</div><button class="popup-close-button" id="popup-close-btn">×</button> </div>`; // main header close div
          //score
          popupHTML += `<div class="popup-heading"><div class="popup-subheading"><span>Flow Logic Index</span> 
                   <span class="fli-index">${avgScore}</span>
                  

                   </div></div>`;


          // // --- Accordion: FLI ---
          // popupHTML += `
          //   <div class="accordion-item" id="accordion-fli">
          //     <div class="accordion-header" style="display:flex; align-items:center; justify-content:space-between; cursor:pointer; padding:10px; background:#dcedeb;">
          //       <span><h6>Flow Logic Index</h6></span><span>▲</span>
          //     </div>
          //     <div class="accordion-content" style="display:block; padding:10px; background:#dcedeb;">
          //       <span>${avgScore}</span>
          //     </div>
          //   </div>
          // `;

          // --- Accordion: Chart ---

          popupHTML += `
              <div class="accordion-item expanded" id="accordion-chart">
                <div class="accordion-header">
                  <span><h6>Avg Home Value History</h6></span><span  style="color: #3d3d3d;">▲</span>
                </div>
                <div class="accordion-content" style="display:block; padding:10px; background:#D6FFFB;">
                  <canvas id="popupChartList" width="300" height="150"></canvas>
                </div>
              </div>
            `;

          // --- Accordion: ROI ---
                   const allROIValues = Object.values(roiData)
                .flatMap(val => Array.isArray(val) ? val : [val]) // flatten and normalize
                .map(val => {
                  // Convert to string, remove %, trim, parse as float
                  const cleaned = parseFloat(String(val).replace('%', '').trim());
                  return isNaN(cleaned) ? null : cleaned;
                })
                .filter(val => val !== null); // Remove any NaN or invalid values

              const overallROIAverage = allROIValues.length
                ? (allROIValues.reduce((sum, val) => sum + val, 0) / allROIValues.length).toFixed(2)
                : "N/A";

              console.log("Overall ROI Average:", overallROIAverage);
          popupHTML += `
  <div class="accordion-item expanded" id="accordion-roi">
    <div class="accordion-header">
    
      <span><h6>ROI</h6></span>
      <div class="accordion-right-info">
        <span class="accordion-average"  style="display:none;">${overallROIAverage}%</span>
      <span  style="color: #3d3d3d;">▲</span>
          </div>
    </div>
    <div class="accordion-content" style="display:block; padding:10px; background:#D6FFFB;">
         <div class="accordion-body">
        <div class="accordion-left">
      ${Object.keys(roiData)
        .map(
          (bedroom) => {
          const values = roiData[bedroom];
              const avg = (
                values.reduce((sum, val) => sum + Number(val), 0) /
                values.length
              ).toFixed(2);
          return `
        <div class="popup-row">
          <span class="popup-left">${bedroom} bd</span>
         <span class="popup-right">${values.join(", ")} </span>
        </div>
         ${values
                  .map((val) => {
                    const numericVal = Number(String(val).replace("%", ""));
                    return `
                      <div class="progress-bar">
                        <div class="progress-fill-colored" style="width:${numericVal}%;"></div>
                        <div class="progress-fill-remaining" style="width:${
                          100 - numericVal
                        }%;"></div>
                        <span class="progress-label">${numericVal}%</span>
                      </div>
                    `;
                  })
                  .join("")}
              `;
        })
        .join("")}
    </div>
     <!-- Right column just for Avg -->
        <div class="accordion-right">
          <div class="avg-box">
            <span class="avg-value"  style="color:${overallROIAverage < 0 ? 'red' : '3d3d3d'}">${overallROIAverage}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

          // --- Accordion: Appreciation ---
  
 const allAppreciationValues = Object.values(appreciationData)
  .flatMap(val => Array.isArray(val) ? val : [val]) // flatten and normalize
  .map(val => {

    // Convert to string, remove %, trim, parse as float
    const cleaned = parseFloat(String(val).replace('%', '').trim());
    return isNaN(cleaned) ? null : cleaned;
  })
  .filter(val => val !== null); // Remove any NaN or invalid values

const overallAppreciationAverage = allAppreciationValues.length
  ? (allAppreciationValues.reduce((sum, val) => sum + val, 0) / allAppreciationValues.length).toFixed(2)
  : "N/A";

console.log("Overall Appreciation Average:", overallAppreciationAverage);          
          popupHTML += `
  <div class="accordion-item expanded" id="accordion-appreciation">
    <div class="accordion-header">
      <span><h6>Appreciation</h6></span>
      <div class="accordion-right-info">
      <span class="accordion-average"  style="display:none;"> ${overallAppreciationAverage}%</span>
      <span class="accordion-arrow" style="color:#3d3d3d;">▲</span>
        </div>
    </div>
    <div class="accordion-content" style="display:block; padding:10px; background:#D6FFFB;">
     <div class="accordion-body">
        <div class="accordion-left">
    ${Object.keys(appreciationData)
                   .map((bedroom) => {
              const values = appreciationData[bedroom];
              const avg = (
                values.reduce((sum, val) => sum + Number(val), 0) / values.length
              ).toFixed(2);

              return `
               <div class="bottom-line">
        <div class="popup-row">
          <span class="popup-left">${bedroom} bd</span>
         <span class="popup-right">${values.join(", ")}</span>
        </div>
         ${values
                  .map((val) => {
                    const numericVal = Number(String(val).replace("%", ""));
                    return `
                      <div class="progress-bar">
                        <div class="progress-fill-colored" style="width:${numericVal}%;"></div>
                        <div class="progress-fill-remaining" style="width:${100 - numericVal}%;"></div>
                        <span class="progress-label">${numericVal}%</span>
                      </div>
                    `;
                  })
                  .join("")}
                    </div>
      `;
         })
        .join("")}
    </div>
     <!-- Right column just for Avg -->
        <div class="accordion-right">
          <div class="avg-box">
            <span class="avg-value"  style="color:${overallAppreciationAverage < 0 ? 'red' : '3d3d3d'}">${overallAppreciationAverage}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

// --- Calculate Overall Avg Home Value ---
const allAvgSalesValues = Object.values(avgSalesData)
  .flatMap(val => Array.isArray(val) ? val : [val]) // flatten
  .map(val => parseFloat(val))
  .filter(val => !isNaN(val)); // clean

const overallAvgSalesValue = allAvgSalesValues.length
  ? Math.floor(allAvgSalesValues.reduce((sum, val) => sum + val, 0) / allAvgSalesValues.length)
  : "N/A";

          // --- Accordion: Avg Sales Value ---
          popupHTML += `
  <div class="accordion-item expanded" id="accordion-sales">
    <div class="accordion-header"  >
      <span><h6>Avg Home Value</h6></span>
      <div class="accordion-right-info">
      <span class="accordion-average"  style="display:none;"> ${formatCurrency(overallAvgSalesValue)}</span>
      <span class="accordion-arrow" style="color:#3d3d3d;">▲</span>
       </div>
    </div>
    <div class="accordion-content" style="display:block; padding:10px; background:#D6FFFB;">
        <div class="accordion-body">
        <div class="accordion-left">
    ${Object.keys(avgSalesData)
        .map(
          (bedroom) => {
                          const values = Array.isArray(avgSalesData[bedroom])
                ? avgSalesData[bedroom]
                : [avgSalesData[bedroom]];
         return  `
        <div class="popup-row">
          <span class="popup-left">${bedroom} bd</span>
                  <span class="popup-right">
                    ${values.map((v) => `$${Math.floor(v).toLocaleString()}`).join(", ")}
                  </span>
        </div>
      `;
           })
        .join("")}
    </div>
      <!-- Right column just for Avg -->
        <div class="accordion-right">
          <div class="avg-box">
            <span class="avg-value">${formatCurrency(overallAvgSalesValue)}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

// --- Calculate Overall Avg Home Value ---
const allAvgYearlyRentValues = Object.values(avgYearlyRentData)
  .flatMap(val => Array.isArray(val) ? val : [val]) // flatten
  .map(val => parseFloat(val))
  .filter(val => !isNaN(val)); // clean

const overallAvgYearlyRentValue = allAvgYearlyRentValues.length
  ? Math.floor(allAvgYearlyRentValues.reduce((sum, val) => sum + val, 0) / allAvgYearlyRentValues.length)
  : "N/A";
          // --- Accordion: Avg Yearly Rent ---
          popupHTML += `
  <div class="accordion-item expanded" id="accordion-yearlyrent">
    <div class="accordion-header"  >
      <span><h6>Avg Yearly Rent</h6></span> 
        <div class="accordion-right-info">
      <span class="accordion-average"  style="display:none;"> ${formatCurrency(overallAvgSalesValue)}</span>
      <span class="accordion-arrow" style="color:#3d3d3d;">▲</span>
       </div>
    </div>
    <div class="accordion-content" style="display:block; padding:10px; background:#D6FFFB;">
        <div class="accordion-body">
        <div class="accordion-left">
    ${Object.keys(avgYearlyRentData)
        .map(
          (bedroom) => {
             
           const values = Array.isArray(avgYearlyRentData[bedroom])
                ? avgYearlyRentData[bedroom]
                : [avgYearlyRentData[bedroom]];
            return `
        <div class="popup-row">
          <span class="popup-left">${bedroom} bd</span>
    <span class="popup-right">${
      values.map((v) => `$${Math.floor(v).toLocaleString()}`).join(", ")}
    </span>
        </div>
              `;
            })
               .join("")}
    </div>
     <!-- Right column just for Avg -->
        <div class="accordion-right">
          <div class="avg-box">
            <span class="avg-value">${formatCurrency(overallAvgYearlyRentValue)}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;
          const firstAvailableCrimeScore = Object.values(crimeScoreData)[0] || "N/A";

        //crime score
          popupHTML += `<div class="popup-heading"><div class="crime-header"><span><h6>Crime Index</h6></span>

                 <span class="crime-index">${
                   firstAvailableCrimeScore !== undefined
                     ? firstAvailableCrimeScore
                     : ""
                 }</span>
 
                 </div>

               </div>`;

          popupHTML += `</div>`; // Close popup div
          

          //           let popupHTML = `
          //   <div class="custom-popup-list"
          //        style="height: ${popupHeight}; transition: height 0.3s ease; overflow-y: auto; position: relative;">
          //     <span id="popupToggleArrow"
          //           style="cursor: pointer; font-size: 20px; position: absolute; top: 10px; right: 50px; z-index: 10;">
          //       ⬆️
          //     </span>

          // `;
          //           // Function to close the popup

          //           // **TOP HEADER SECTION**
          //           popupHTML += `
          //                       <div class="popup-header">

          //                           <div class="popup-title-wrap"><div class="popup-text">
          //                               <div class="popup-title">
          //                                   ${pincode} | ${city}
          //                               </div>
          //                               <div class="popup-subtitle"> ${county} | (${state})</div>
          //                           </div>

          //                   `;

          //           const roiData = {};
          //           const scoreData = {};
          //           const appreciationData = {};
          //           const avgSalesData = {};
          //           const avgMonthlyRentData = {};
          //           const avgYearlyRentData = {};
          //           let favourites = 0;
          //           // Calculate average for each year
          //           const latest_year = firstResult.last_updated_sales_year;

          //           // Define offsets for historical sales data fields
          //           const salesFields = [
          //             { offset: 3, field: "sales_data_three" },
          //             { offset: 2, field: "sales_data_two" },
          //             { offset: 1, field: "sales_data_one" },
          //             { offset: 0, field: "avg_current_sales" },
          //           ];

          //           // Initialize structures
          //           const salesData = {};
          //           const averageSales = {};

          //           // Initialize salesData with dynamic year keys
          //           salesFields.forEach(({ offset }) => {
          //             const year = (latest_year - offset).toString();
          //             salesData[year] = [];
          //           });
          //           // Group properties by bedrooms
          //           responseData.results.forEach((property) => {
          //             const bedrooms = property.bedrooms || "Unknown";

          //             responseData.results.forEach((property) => {
          //               salesFields.forEach(({ offset, field }) => {
          //                 const year = (latest_year - offset).toString();
          //                 const value = parseFloat(property[field]);
          //                 if (!isNaN(value)) {
          //                   salesData[year].push(value);
          //                 }
          //               });
          //             });

          //             // Calculate average sales for each year
          //             Object.keys(salesData).forEach((year) => {
          //               const values = salesData[year];
          //               const sum = values.reduce((a, b) => a + b, 0);
          //               averageSales[year] = values.length ? sum / values.length : 0;
          //             });

          //             // ROI data
          //             if (!roiData[bedrooms]) roiData[bedrooms] = [];
          //             roiData[bedrooms].push(`${Number(property.roi).toFixed(2)}%`);

          //             // score data
          //             if (!scoreData[bedrooms]) scoreData[bedrooms] = [];

          //             // Ensure score is a valid number before adding
          //             const score = parseFloat(property.score);
          //             if (!isNaN(score)) {
          //               scoreData[bedrooms].push(score);
          //             }
          //             // Appreciation data
          //             if (!appreciationData[bedrooms]) appreciationData[bedrooms] = [];
          //             appreciationData[bedrooms].push(
          //               `${Number(property.appreciation).toFixed(2)}%`
          //             );

          //             // Avg Sales data
          //             if (!avgSalesData[bedrooms]) avgSalesData[bedrooms] = 0;
          //             avgSalesData[bedrooms] += parseFloat(property.avg_current_sales);

          //             // Avg Monthly data
          //             if (!avgMonthlyRentData[bedrooms]) avgMonthlyRentData[bedrooms] = 0;
          //             avgMonthlyRentData[bedrooms] += parseFloat(
          //               property.avg_monthly_rent
          //             );

          //             // Avg Yearly data
          //             if (!avgYearlyRentData[bedrooms]) avgYearlyRentData[bedrooms] = 0;
          //             avgYearlyRentData[bedrooms] += parseFloat(property.avg_yearly_rent);

          //             //favourites
          //             // favourites = property.is_favorite;
          //             if (property.is_favorite === true) {
          //               favourites = 1;
          //             }
          //           });

          //           const totalScores = Object.values(scoreData)
          //             .flat()
          //             .filter((score) => !isNaN(score));
          //           const avgScore =
          //             totalScores.length > 0
          //               ? Math.round(
          //                   totalScores.reduce((acc, val) => acc + val, 0) /
          //                     totalScores.length
          //                 )
          //               : 0; // Default to 0 if no valid scores

          //           // <!-- Heart Icon for Favorite -->

          //           if (favourites === 1) {
          //             popupHTML += `
          //                           <a id="favorite-button" class="popup-favorite-button highlighted">
          //                               <img src="/assets/favorites-fill.svg" alt="Favorite" /> <!-- Heart symbol -->
          //                           </a>`;
          //             isFavorite = true; // Set isFavorite to true since it's already marked as a favorite
          //           } else {
          //             popupHTML += `
          //                           <a id="favorite-button" class="popup-favorite-button">
          //                               <img src="/assets/favorites.svg" alt="Not Favorite" /> <!-- Heart symbol -->
          //                           </a>`;
          //             isFavorite = false; // Set isFavorite to false
          //           }
          //           popupHTML += `</div><button class="popup-close-button" id="popup-close-btn">×</button> </div>`; // main header close div
          //           //score
          //           popupHTML += `<div class="popup-heading"><div class="popup-subheading"><span>Flow Logic Index</span>
          //                    <span>${avgScore}</span>

          //                    </div></div>`;

          //           //graph

          //           popupHTML += `<div class="popup-content">
          //                        <canvas id="popupChartList" width="300" height="150"></canvas>

          //                       </div> `;

          //           //    <PopupChart averageSales={averageSales} />
          //           //ROI
          //           popupHTML += `<div class="popup-heading"><div class="popup-subheading">ROI</div>
          //                   `;
          //           // Append ROI details
          //           Object.keys(roiData).forEach((bedroom) => {
          //             popupHTML += `
          //                           <div class="popup-row">
          //                               <span class="popup-left">${bedroom} bd</span>
          //                               <span class="popup-right"> ${roiData[
          //                                 bedroom
          //                               ].join(", ")}</span>
          //                           </div>
          //                       `;
          //           });

          //           popupHTML += `</div>`;

          //           // Add Appreciation section
          //           popupHTML += `<div class="popup-heading"><div class="popup-subheading">Appreciation</div>`;

          //           // Iterate through appreciation data and format it as rows
          //           Object.keys(appreciationData).forEach((bedroom) => {
          //             popupHTML += `
          //                           <div class="popup-row">
          //                               <span class="popup-left">${bedroom} bd</span>
          //                               <span class="popup-right">${appreciationData[
          //                                 bedroom
          //                               ].join(", ")}</span>
          //                           </div>
          //                       `;
          //           });

          //           popupHTML += `</div>`;

          //           // Add Avg Sales section
          //           popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Sales Value</div>`;

          //           // Iterate through Sales data and format it as rows
          //           Object.keys(avgSalesData).forEach((bedroom) => {
          //             popupHTML += `
          //                            <div class="popup-row">
          //                                <span class="popup-left">${bedroom} bd</span>
          //                               <span class="popup-right">$${Math.floor(
          //                                 avgSalesData[bedroom]
          //                               ).toLocaleString()}</span>
          //                            </div>
          //                        `;
          //           });

          //           popupHTML += `</div>`;

          //           //                   // Add Avg Montly Rent section
          //           //  popupHTML += `<div className="popup-heading"><div className="popup-subheading">Avg Monthly Rent</div>`;

          //           //  // Iterate through Avg Monthly Rent data and format it as rows
          //           //  Object.keys(avgMonthlyRentData).forEach(bedroom => {
          //           //      popupHTML += `
          //           //          <div className="popup-row">
          //           //              <span className="popup-left">${bedroom} bd</span>
          //           //             <span className="popup-right">$${avgMonthlyRentData[bedroom].toLocaleString()}</span>

          //           //          </div>
          //           //      `;
          //           //  });

          //           //  popupHTML +=`</div>`;

          //           // Add Avg Yearly Rent section
          //           popupHTML += `<div class="popup-heading"><div class="popup-subheading">Avg Yearly Rent</div>`;

          //           // Iterate through Avg Monthly Rent data and format it as rows
          //           Object.keys(avgYearlyRentData).forEach((bedroom) => {
          //             popupHTML += `
          //                              <div class="popup-row">
          //                                  <span class="popup-left">${bedroom} bd</span>
          //                                 <span class="popup-right">$${avgYearlyRentData[
          //                                   bedroom
          //                                 ].toLocaleString()}</span>

          //                              </div>
          //                          `;
          //           });

          //           popupHTML += `</div>`;

          //           popupHTML += `</div>`; // Close popup div

          // const customPopupControl = new CustomPopupControl(popupHTML);
          // map.addControl(customPopupControl, 'top-right');
          //customPopupRef.current = customPopupControl; // Store it in ref
          document.getElementById("detailed_popup").style.display = "block";

          document.getElementById("detailed_popup").innerHTML = popupHTML;
          setPopupHTML(popupHTML);

          // --- Accordion toggle logic (after injecting popupHTML) ---
          document.querySelectorAll(".accordion-header").forEach((header) => {
            header.addEventListener("click", () => {
              const item = header.parentElement;
              const content = item.querySelector(".accordion-content");
              const expanded = content.style.display === "block";
              if (expanded) {
                content.style.display = "none";
                item.style.color = "#3d3d3d";
                header.querySelector("span:last-child").innerText = "▼";
              } else {
                content.style.display = "block";
                item.style.color = "#3d3d3d";
                header.querySelector("span:last-child").innerText = "▲";
              }
            });
          });

          // Attach click after injection

          const outerPopup = document.getElementById("detailed_popup");
          const arrowEl = document.getElementById("popupToggleArrow");
          
              // Add click event to toggle arrow rotation
if (arrowEl) {
  arrowEl.addEventListener("click", () => {
    arrowEl.classList.toggle("active");
  });
}

          // Toggle height on click
          arrowEl.addEventListener("click", function () {
            if (outerPopup.style.maxHeight === "100vh") {
              outerPopup.style.maxHeight = "300px"; // collapse
            } else {
              outerPopup.style.maxHeight = "100vh"; // expand
              outerPopup.style.height = "auto";
            }
          });
          setTimeout(() => {
            const closeBtn = document.getElementById("popup-close-btn");
            if (closeBtn) {
              closeBtn.onclick = () => {
                setPopupHTML(null);
                document.getElementById("detailed_popup").style.display =
                  "none";
              };
            }
          }, 0);

          const favoriteButton = document.getElementById("favorite-button");
          if (favoriteButton) {
            favoriteButton.addEventListener("click", () => {
              // toggleFavorite(pincode); // Use the location (zipcode) passed to the function
              toggleFavorite(pincode, isFavorite);
              updatePopupHeartIcon(!isFavorite); // Instantly update heart icon
              isFavorite = !isFavorite;
            });
          }

          setTimeout(() => {
            let canvas;

            canvas = document.getElementById("popupChartList");

            if (popupChartListRef.current) {
              popupChartListRef.current.destroy();
            }
            if (canvas) {
              const ctx = canvas.getContext("2d");
              //const years = ['2021', '2022', '2023', '2024']; // Years on the X-axis
              const years = Array.from({ length: 4 }, (_, i) =>
                String(latest_year - 3 + i)
              );
              const avgCurrentSales = years.map(
                (year) => averageSales[year] || 0
              );

              popupChartListRef.current = new Chart(ctx, {
                type: "line",
                data: {
                  labels: years, // X-axis labels
                  datasets: [
                    {
                      label: "Avg Home Value",
                      data: avgCurrentSales, // Y-axis data
                      borderColor: "rgba(75, 192, 192, 1)",
                      borderWidth: 2,
                      fill: false,
                    },
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: { display: true, labels: { boxWidth: 0 } },
                    tooltip: {
                      callbacks: {
                        // Format tooltip to include $ sign and commas for thousands
                        label: function (tooltipItem) {
                          //return '$' + tooltipItem.raw.toLocaleString(); // Formats the tooltip value with $
                          return formatCurrency(tooltipItem.raw);
                        },
                      },
                    },
                  },
                  scales: {
                    x: { title: { display: false, text: "Year" } },
                    y: {
                      //beginAtZero: true,
                      title: { display: false, text: "Value ($)" },
                      ticks: {
                        // Format the y-axis ticks to include $ and commas
                        callback: function (value) {
                          //return '$' + value.toLocaleString(); // Formats Y-axis values with $
                          return formatCurrency(value); // Use the custom formatter
                        },
                      },
                    },
                  },
                },
              });
            } else {
              console.error("Chart canvas not found.");
            }
          }, 100); // Delay of 100ms to ensure canvas is rendered before Chart.js is initialized
        }
      })
      .catch((error) => {
        console.error("Error fetching boundary:", error);
      });
  };
  // Fetch user's favorite zipcodes
  // useEffect(() => {
  //   fetch("https://beta.flowlogic.com/zip/favorite/all/", {
  //     headers: { Authorization: `Bearer ${authToken}` },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => setFavoriteZipcodes(data.favourites || []))
  //     .then((data) => {
  //       // setFavoritePropertyList(data.favourites?.map(f => String(f.zipcode)) || []);
  //       setFavoriteZipcodes(data.favourites || []);
  //       setFavoritePropertyList(data.favourites || []);
  //       console.log(
  //         "favoritePropertyList INSIDE USEFFECT",
  //         favoritePropertyList
  //       );
  //     })
  //     .catch((err) => console.error("Failed to load favorites", err));
  // }, []);


useEffect(() => {
  const fetchFavorites = async () => {
    try {
      const res = await fetch("https://beta.flowlogic.com/zip/favorite/filter-all", {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      const data = await res.json();
      console.log("API Response:", data);

      // Store the full feature list
      // setFavoritePropertyList(data.features || []);

       const properties = (data.features || []).map((feature) => {
        const [lon, lat] = feature.geometry.coordinates;
        const modifiedROI = parseInt(feature.properties.roi, 10);
        const modifiedAppreciation = parseInt(feature.properties.appreciation, 10);
        const sales = parseInt(feature.properties.sales, 10);

        return {
          zipcode: feature.properties.zipcode,
          roi: modifiedROI,
          bedrooms: feature.properties.bedrooms,
          state: feature.properties.state,
          rent: feature.properties.rent,
          city: feature.properties.city,
          score: feature.properties.score,
          sales: sales,
          appreciation: modifiedAppreciation,
          latitude: lat,
          longitude: lon,
          rawroi:feature.properties.roi,
          rawappreciation:feature.properties.appreciation,
          favorite: true, // Since this API only returns favorites
        };
      });

      console.log("Favorite Property List:", properties);
      properties.sort((a, b) => b.roi - a.roi);

      // Store favorites in the same format as your main dataset
      setFavoritePropertyList(properties);
      console.log("favoritePropertyList:*********", properties);


      // Extract just the zipcodes
      const zips = (data.features || []).map(f => String(f.properties.zipcode));
      setFavoriteZipcodes(zips);
      setUpdatedFavoritePropertyList(properties);

      console.log("Zipcodes:", zips);
    } catch (err) {
      console.error("Failed to load favorites", err);
    }
  };

  fetchFavorites();
}, [activeTab]);



  const sortProperties = (properties, key, order) => {
  console.log(`Sorting by ${key} in ${order} order`);
  console.log(`Sorting by sortproperties:*******`, properties);

    return properties.sort((a, b) => {
      if (order === "asc") {
        return a[key] - b[key];
      } else {
        return b[key] - a[key];
      }
    });
  };
  const getSortArrow = (key) => {
    if (sortKey !== key) return "";
    return sortOrder === "asc" ? "↑" : "↓";
  };

  const sortByROI = (properties) => {
    return [...properties].sort((a, b) => a.score - b.score);
  };

  // Function to change views
  const handleViewChange = (view) => {
    setPopupHTML(null);
    setCurrentView(view);
    setSearchPincode(""); // to avoid the color selected

    //compare button disabled and compare arry null
    setIsCompareClicked(false);
    const clearedCompareList = [];
    setCompareList(clearedCompareList);

    //alert(compareList.length);
    if (view === "list") {
      if (compareList.length > 0 || popupHTML) {
        document.getElementById("detailed_popup").style.display = "block";
      } else {
        document.getElementById("detailed_popup").style.display = "none";
      }
    } else if (view === "split") {
      document.getElementById("detailed_popup").style.display = "none";
    } else {
      document.getElementById("detailed_popup").style.display = "none";
    }
  };

  class ResetViewControl {
    constructor({ initialCenter, initialZoom }) {
      this.initialCenter = initialCenter; // Initial center of the map
      this.initialZoom = initialZoom; // Initial zoom level
    }

    onAdd(map) {
      this.map = map;

      // Create the button element
      this.button = document.createElement("button");
      this.button.className = "mapboxgl-ctrl-icon mapboxgl-ctrl-reset";
      this.button.type = "button";
      this.button.title = "Reset View";
      this.popupRef = popupRef; // Reference to the popup
      this.customPopupRef = customPopupRef; // Reference to the custom popup control
      this.button.innerHTML = "&#x21BB;"; // Use a refresh icon or any other icon

      // Add a click event listener to reset the map view
      this.button.addEventListener("click", () => {
        this.map.flyTo({
          center: this.initialCenter,
          zoom: this.initialZoom,
          essential: true, // Ensures the animation is not interrupted by user interactions
        });

        if (map.getLayer("state-boundary")) {
          map.removeLayer("state-boundary");
        }
        if (map.getLayer("highlighted-region")) {
          map.removeLayer("highlighted-region");
        }
        if (map.getSource("state-boundary")) {
          map.removeSource("state-boundary");
        }
        setCurrentStateId(null);
        setCurrentCity(null);
        // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
        const input = document.querySelector(".mapboxgl-ctrl-geocoder--input");
        if (input) {
          input.value = "";
        }

        // Popup cleanup logic
        if (this.popupRef.current) {
          console.log("popup removed");
          this.popupRef.current.remove(); // Ensure popup is removed when unmounting
          this.popupRef.current = null;
        }

        if (this.customPopupRef.current) {
          this.map.removeControl(this.customPopupRef.current);
          this.customPopupRef.current = null;
        }
      });

      // Create the container for the button
      this.container = document.createElement("div");
      this.container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
      this.container.appendChild(this.button);

      return this.container;
    }

    onRemove() {
      // Clean up the button and container
      this.button.removeEventListener("click", this.resetView);
      this.container.parentNode.removeChild(this.container);
      this.map = undefined;
    }
  }
  // Map initialization
  useEffect(() => {
    const initialCenter = isSubscribed
      ? [-95.7129, 37.0902]
      : [-86.2583, 39.8494]; // Center of US
    // const initialZoom = 3.5; // Initial zoom level
    const initialZoom = isSubscribed ? 3.5 : 9; // Initial zoom level
    const map = new mapboxgl.Map({
      container: mapContainer.current,
      //container: 'map',
      //style: 'mapbox://styles/mapbox/streets-v11',
      style: "mapbox://styles/mapbox/light-v11",
      center: initialCenter,
      zoom: initialZoom,
      projection: "mercator",
      // Restrict map movement to USA (with Alaska + Hawaii)
      maxBounds: [
        [-179.9, 17.5], // Southwest corner (Hawaii + Pacific)
        [-64.5, 71.5], // Northeast corner (Maine + Alaska North)
      ],

      // Intercept requests to modify headers
      transformRequest: (url, resourceType) => {
        // Check if the request is for your tile endpoint
        if (url.startsWith("https://beta.flowlogic.com/tilesgl/data/point/")) {
          return {
            url: url,
            headers: { Authorization: `Bearer ${authToken}` },
          };
        }
        // Default behavior for other requests
        return { url: url };
      },
    });

    mapRef.current = map;
    map.addControl(new mapboxgl.NavigationControl(), "bottom-right");
    //console.log("map entry");
    map.on("load", () => {
      if (isSubscribed) {
        map.addSource("vector-tiles", {
          type: "vector",
          tiles: [
            "https://beta.flowlogic.com/tilesgl/data/point/{z}/{x}/{y}.pbf",
          ],
          // tiles: ["http://localhost:8080/data/point/{z}/{x}/{y}.pbf"]
        });

        const appreciationColors = [
          "step",
          ["get", "appreciation"],
          "#acacac",
          0,
          "#FFE36B",
          5,
          "#FFB36B",
          10,
          "#FE5C5C",
          15,
          "#F26BFF",
          20,
          "#CE1E50",
        ];

        const defaultColors = [
          "step",
          ["get", activeMetric],
          "#acacac",
          0,
          "#acacac",
          5,
          "#FFE36B",
          10,
          "#FFB36B",
          15,
          "#FE5C5C",
          20,
          "#F26BFF",
          25,
          "#CE1E50",
        ];

        map.addLayer({
          id: "point-layer",
          type: "circle",
          source: "vector-tiles",
          "source-layer": "mapplotting",
          // 'source-layer': 'data',
          paint: {
            "circle-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              3,
              4,
              10,
              6,
              16,
              8,
              20,
              10,
              24,
            ],
            // 'circle-color': [
            //   // 'step', ['get', 'roi'],
            //   'step',
            //   ['get', activeMetric],
            //   '#acacac',
            //   0, '#acacac',
            //   5, '#FFE36B',
            //   10, '#FFB36B',
            //   15, '#FE5C5C',
            //   20, '#F26BFF',
            //   25, '#CE1E50',
            // ],
            "text-color": "#000",

            "circle-color":
              activeMetric === "appreciation"
                ? appreciationColors
                : defaultColors,
          },
          layout: {
            // This is the key part
            "circle-sort-key": ["get", "roi"], // Higher ROI = drawn later = on top
            "text-field": [
              "to-string",
              ["to-number", ["round", ["get", activeMetric]]],
            ],
            "text-size": 10,
            "text-allow-overlap": false,
          },
        });

        // map.addLayer({
        //   id: "roi-labels1",
        //   type: "symbol",
        //   source: "vector-tiles",
        //   "source-layer": "mapplotting",
        //   minzoom: 4,
        //   layout: {
        //     "text-field": [
        //       "to-string",
        //       ["to-number", ["round", ["get", activeMetric]]],
        //     ],
        //     "text-size": 10,
        //     "text-allow-overlap": false,
        //   },
        //   paint: {
        //     "text-color": "#000",
        //     // 'text-halo-color': '#fff',
        //     // 'text-halo-width': 1
        //   },
        // });
      } else {
        // Unsubscribed users: restricted data
        map.addSource("vector-tiles", {
          type: "vector",
          //  tiles: ["https://demo.flowlogic.com/tilesgl/data/point/{z}/{x}/{y}.pbf"]
          tiles: [
            // "https://demo.flowlogic.com/tilesgl/data/unsubscribed/{z}/{x}/{y}.pbf",
            // "https://beta.flowlogic.com/tilesgl/data/unsubscribed/{z}/{x}/{y}.pbf",
            "https://beta.flowlogic.com/tilesgl/data/point/{z}/{x}/{y}.pbf",
          ],
        });
        map.addLayer({
          id: "point-layer",
          type: "circle",
          source: "vector-tiles",
          // 'source-layer': 'mapplotting', // 'mapplotting' for free layer
          "source-layer": "indianapolis",
          paint: {
            "circle-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              3,
              4,
              10,
              6,
              16,
              8,
              20,
              10,
              24,
            ],
            "circle-color": [
              "step",
              ["get", activeMetric],
              "#acacac",
              0,
              "#acacac",
              5,
              "#FFE36B",
              10,
              "#FFB36B",
              15,
              "#FE5C5C",
              20,
              "#F26BFF",
              25,
              "#CE1E50",
            ],
          },
          layout: {
            "circle-sort-key": ["get", "roi"],
          },
        });

        map.addLayer({
          id: "roi-labels-2",
          type: "symbol",
          source: "vector-tiles",
          "source-layer": "indianapolis",
          minzoom: 4,
          layout: {
            // 'text-field': ['get', activeMetric],
            // Show only integer part
            "text-field": [
              "to-string",
              ["to-number", ["round", ["get", activeMetric]]],
            ],
            "text-size": 10,
            "text-allow-overlap": false,
          },
          paint: {
            "text-color": "#000", // White text for contrast on gray
            // 'text-halo-color': '#222', // Optional: add a halo for better visibility
            // 'text-halo-width': 1
          },
        });
      }
    });
    // Add the custom ResetViewControl
    map.addControl(
      new ResetViewControl({
        initialCenter: initialCenter,
        initialZoom: initialZoom,
        popupRef: popupRef, // Pass the popup reference
        customPopupRef: customPopupRef, // Pass the custom popup reference
      }),
      "bottom-right" // Position it alongside the zoom controls
    );
    // map.on('sourcedata', (e) => {
    //   if (e.sourceId === 'vector-tiles' && e.isSourceLoaded) {
    //     fetchFeatureData();
    //   }
    // });

    // map.on('moveend', () => {
    //   clearTimeout(moveEndTimeout);
    //   moveEndTimeout = setTimeout(() => {
    //     fetchFeatureData();
    //   }, 30); // Delay to avoid too many calls
    // });

    map.on("sourcedata", (e) => {
      if (e.sourceId === "vector-tiles" && e.isSourceLoaded) {
        // fetchFeatureData();
        debouncedFetchFeatureData();
      }
    });

    map.on("moveend", () => {
      debouncedFetchFeatureData();
    });

    map.on("click", "point-layer", (e) => {
      const feature = e.features[0];
      const { roi, appreciation, score, zipcode, city, state } =
        feature.properties;

      const coordinates = feature.geometry.coordinates;

      const popupContent = `
        <div class="tooltipOuter">
          <div class="tooltipTitle"><span>${zipcode}</span><span class="grey">${city}, ${state}</span></div>
          <div class="tooltipContentOuter">
              <div class="tooltipContent">
                  <div class="tooltipValues"><span><strong>ROI</strong></span> <span>${parseInt(
                    roi
                  )}%</span></div>
                  <div class="tooltipValues"><span><strong>Appreciation</strong></span> <span>${parseInt(
                    appreciation
                  )}%</span></div>
                  <div class="tooltipValues"><span><strong>FLI</strong></span> <span>${parseInt(
                    score
                  )}</span></div>
              </div>
              <div class="tooltipViewBtn">
                  <button id="viewMoreBtn">
                      <span>Explore</span> <img src="/assets/arw-grey.svg" />
                  </button>
              </div>
          </div>
        </div>
      `;

      //   new mapboxgl.Popup({ offset: 15, closeButton: true })
      //     .setLngLat(e.lngLat)
      //     .setHTML(popupContent)
      //     .addTo(map);

      // // Attach "View More" button event AFTER rendering
      // setTimeout(() => {
      //     const viewMoreBtn = document.getElementById("viewMoreBtn");
      //     if (viewMoreBtn) {
      //         viewMoreBtn.onclick = () => handleLocationSelect(zipcode, map, setCurrentPopup);
      //     }
      // }, 100);

      // Fixed code - store popup reference and close it when opening detailed popup
      const smallPopup = new mapboxgl.Popup({ offset: 15, closeButton: true })
        .setLngLat(e.lngLat)
        .setHTML(popupContent)
        .addTo(map);

      // Store reference to small popup for cleanup
      popupRef.current = smallPopup;

      // Attach "View More" button event AFTER rendering
      setTimeout(() => {
        const viewMoreBtn = document.getElementById("viewMoreBtn");
        if (viewMoreBtn) {
          viewMoreBtn.onclick = () => {
            // Close the small popup before opening detailed popup
            if (popupRef.current) {
              popupRef.current.remove();
              popupRef.current = null;
            }
            handleLocationSelect(zipcode, map, setCurrentPopup);
          };
        }
      }, 100);
    });

    // Track the last selected state
    let lastSelectedState = null;

    //Statewise selection
    map.on("click", async (e) => {
      // Check if marker was clicked
      const features = map.queryRenderedFeatures(e.point, {
        layers: ["point-layer"],
      });
      if (features.length > 0) return;

      const clickedLngLat = e.lngLat;
      const clickedPoint = turf.point([clickedLngLat.lng, clickedLngLat.lat]);

      // Ignore clicks inside popups
      const isMarkerClick =
        e.originalEvent.target.classList.contains("mapboxgl-popup");
      const clickedEl = e.originalEvent.target;
      const clickedInsidePopup = clickedEl.closest(".mapboxgl-popup");
      if (isMarkerClick || clickedInsidePopup) return;

      try {
        setSelectedZipcode(null);
        setCompareList([]);
        const response = await fetch("/assets/usa.geojson");
        const geojson = await response.json();

        // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
        const input = document.querySelector(".mapboxgl-ctrl-geocoder--input");
        if (input) {
          input.value = "";
        }

        const matchedFeature = geojson.features.find((feature) => {
          return turf.booleanPointInPolygon(clickedPoint, feature);
        });

        if (matchedFeature) {
          const clickedState = matchedFeature.properties.name;

          if (clickedState === lastSelectedState) {
            // Deselect state
            console.log("Deselected:", clickedState);
            lastSelectedState = null;
            setCurrentPopup(null);
            //  clear highlights
            // REMOVE EXISTING LAYERS AND SOURCES SAFELY
            if (map.getLayer("state-boundary")) {
              map.removeLayer("state-boundary");
            }
            if (map.getLayer("highlighted-region")) {
              map.removeLayer("highlighted-region");
            }
            if (map.getSource("state-boundary")) {
              map.removeSource("state-boundary");
            }
            setCurrentStateId(null);
            setCurrentCity(null);
          } else {
            console.log("Selected:", clickedState);
            lastSelectedState = clickedState;
            handleLocationSelect(clickedState, map, setCurrentPopup);
          }
        } else {
          console.log("Clicked location is not inside any state");
          lastSelectedState = null;
          setCurrentPopup(null);
        }
      } catch (err) {
        console.error("Error checking point in polygon:", err);
      }
    });

    // Gray mask and Indianapolis border for unsubscribed users
    if (!isSubscribed) {
      map.on("load", async () => {
        // Indianapolis city coordinates
        const cityCoordinates = [
          [
            [-86.45, 40.05],
            [-86.25, 40.1],
            [-86.0, 40.0],
            [-85.95, 39.85],
            [-85.9, 39.7],
            [-86.0, 39.55],
            [-86.25, 39.5],
            [-86.45, 39.6],
            [-86.5, 39.75],
            [-86.45, 40.05],
          ],
        ];
        // Outer world polygon
        const outerCoordinates = [
          [-180, -90],
          [180, -90],
          [180, 90],
          [-180, 90],
          [-180, -90],
        ];
        // Mask polygon with a hole (city inside hole)
        const maskWithHole = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Polygon",
                coordinates: [outerCoordinates, ...cityCoordinates],
              },
              properties: {},
            },
          ],
        };
        // Add mask with city hole
        map.addSource("inactive-mask", {
          type: "geojson",
          data: maskWithHole,
        });
        map.addLayer({
          id: "gray-outside",
          type: "fill",
          source: "inactive-mask",
          layout: {},
          paint: {
            "fill-color": "#000",
            "fill-opacity": 0.4,
          },
        });
        // Add Indianapolis city border
        const cityGeoJSON = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              properties: { name: "Indianapolis" },
              geometry: {
                type: "Polygon",
                coordinates: cityCoordinates,
              },
            },
          ],
        };
        map.addSource("indianapolis-city", {
          type: "geojson",
          data: cityGeoJSON,
        });
        map.addLayer({
          id: "indianapolis-outline",
          type: "line",
          source: "indianapolis-city",
          layout: {},
          paint: {
            "line-color": "#0f5132",
            "line-width": 2,
          },
        });
        // Blocker to disable interactivity outside
        map.addLayer({
          id: "inactive-blocker",
          type: "fill",
          source: "inactive-mask",
          layout: {},
          paint: {
            "fill-color": "#000000",
            "fill-opacity": 0,
          },
        });
        // Show toast if user clicks outside Indianapolis
        map.on("click", (e) => {
          const features = map.queryRenderedFeatures(e.point, {
            layers: ["gray-outside"],
          });
          if (features.length !== 0) {
            toast.error("This area is outside your subscription.");
          }
        });
        map.on("click", "inactive-blocker", (e) => {
          e.preventDefault();
          // toast.error("Interaction is disabled outside Indianapolis.");
          console.log("Interaction is disabled outside Indianapolis.");
        });
      });
    }

    setMap(map);

    map.on("style.load", () => {
      setStyleLoaded(true); // Set the flag to true when the style is loaded
    });

    // Add Mapbox Geocoder for state/region search
    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      countries: "us",
      // types: 'region,district,postcode', // Search for states/regions only
      types: "region,place,postcode",
      placeholder: "Search for a state / city / zipcode",
      mapboxgl: mapboxgl,
      marker: false,
    });
    // Store globally so Header can re-attach
    window.geocoderInstance = geocoder;
    window.initializedMap = map;
    // Add geocoder to the map
    // initializedMap.addControl(geocoder, 'top-left');

    if (geocoderContainerRef.current) {
      geocoderContainerRef.current.appendChild(geocoder.onAdd(map));
    }
    geocoder.on("result", (event) => {
        const inputEl = geocoderContainerRef.current?.querySelector(
    ".mapboxgl-ctrl-geocoder--input"
  );

  if (inputEl) {
    const clearInput = () => {
      inputEl.value = "";
      // optional: trigger an input event so geocoder UI refreshes
      inputEl.dispatchEvent(new Event("input", { bubbles: true }));
      // remove listeners after clearing (so it only happens once)
      inputEl.removeEventListener("focus", clearInput);
      inputEl.removeEventListener("mouseenter", clearInput);
    };

    // clear on either click/focus or hover
    inputEl.addEventListener("focus", clearInput);
    inputEl.addEventListener("mouseenter", clearInput);
  }
      // When a state is selected, zoom into the state and highlight its boundaries
      const result = event.result;
      const stateName = result.text; // Get the state name
      const stateCenter = result.center; // Coordinates for the state center
      const zipCode = result.text;
      console.log("stateName", stateName);
      console.log("detail popup", setCurrentPopup);
      //setCurrentPopup(null);
      //setSearchPincode(stateName); //set the search value
      //setPopupData(null);
      if (currentPopup) {
        currentPopup.remove(); // Close the previous popup
      }
      //document.querySelector(".mapboxgl-ctrl-top-right").innerHTML  = "";
      handleLocationSelect(stateName, map, setCurrentPopup);
    });

    // return () => map.remove();
    return () => {
      map.remove();
      window.geocoderInstance = null;
      window.initializedMap = null;
    };
  }, [isSubscribed]);
  // }, [isSubscribed, activeMetric]);

  useEffect(() => {
    if (map && (currentView === "map" || currentView === "split")) {
      setTimeout(() => {
        map.resize();
      }, 200); // give layout some time to update
    }
  }, [currentView, map]);

  useEffect(() => {
    if (map && (currentView === "map" || currentView === "split")) {
      requestAnimationFrame(() => {
        map.resize();
      });
    }
  }, [currentView, map]);

  const handleDeleteClick = (e, zipcode, currentFav) => {
    e.stopPropagation();
    setZipToRemove({ zipcode, favorite: currentFav });
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    if (zipToRemove) {
      toggleFavorite(zipToRemove.zipcode, zipToRemove.favorite);
    }
    setShowConfirmModal(false);
    setZipToRemove(null);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
    setZipToRemove(null);
  };
  

  //handle row click from list
  const handleRowClick = (zipcode, map, setCurrentPopup, currentView) => {
    setSelectedZipcode(zipcode);
    setSearchPincode(zipcode); // Set search value
    //  Clear popup details
    setPopupHTML(null);
    ///compare delection checkbox
    // setCheckedItems({});

    if (currentView === "list") {
      handleLocationSelectList(zipcode, map, setCurrentPopup, currentView);
    } else {
      //setCompareList([zipcode]);
      handleLocationSelect(zipcode, map, setCurrentPopup, currentView);
    }
  };

  //compare
  const handleCompare = (zipcode) => {
    setCompareList((prevList) => {
      let updatedList = [...prevList];

      //  Remove if already in list
      if (updatedList.includes(zipcode)) {
        setSearchPincode("");
        updatedList = updatedList.filter((item) => item !== zipcode);
      }
      //  Add if not present
      else {
        if (updatedList.length >= 4) {
          toast.error("You can compare up to 4 ZIP codes only.");
          return prevList;
        }
        updatedList.push(zipcode);
      }
      //alert(updatedList.length );
      //  Handle switching modes
      if (updatedList.length === 0) {
        // none left → close popup

        //setIsCompareClicked(false);
        setSearchPincode(""); // to avoid the color selected
        setPopupHTML(null);
        document.getElementById("detailed_popup").style.display = "none";
      } else if (updatedList.length === 1) {
        // only one left → show row details
        //setIsCompareClicked(false);
        const singleZip = updatedList[0];
        //setIsCompareClicked(false); // exit compare mode
        document.getElementById("detailed_popup").style.display = "none";
        handleRowClick(singleZip, map, setCurrentPopup, currentView);
      } else {
        // 2+ → compare mode
        setIsCompareClicked(true);
        setTimeout(() => {
          showCompareDetails(updatedList, originalPropertyList);
        }, 0);
        if (currentView === "list") {
          document.getElementById("detailed_popup").style.display = "block";
        }
      }

      return updatedList;
    });
  };

  const showCompareDetails = (compareList, originalPropertyList) => {
      const propertySource =
    activeTab === "favorites" ? favoritePropertyList : originalPropertyList;
    // Cleanup previous charts safely
    if (window.metricChartInstance) {
      window.metricChartInstance.destroy();
      window.metricChartInstance = null;
    }
    if (window.salesChartInstance) {
      window.salesChartInstance.destroy();
      window.salesChartInstance = null;
    }
    if (window.barChartInstance) {
      window.barChartInstance.destroy();
      window.barChartInstance = null;
    }

    const matchedProperties = originalPropertyList.filter((property) =>
      compareList.includes(property.zipcode)
    );

    const selectedZip = selectedZipcode;
    const zipOrder = [
      selectedZip,
      // selectedZipcode,
      ...compareList.filter((zip) => zip !== selectedZip),
    ];

    const sortedProperties = zipOrder
      // .map((zip) => matchedProperties.find((p) => p.zipcode === zip))
       .map((zip) => propertySource.find((p) => p.zipcode === zip))
      .filter(Boolean);

      if (sortedProperties.length < zipOrder.length) {
  console.warn("Some selected zipcodes have no data and will not be shown.");
}

    // const fixedColors = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728"];
    const fixedColors = ["#1814F3", "#16DBCC", " #D009D0", "#16A9F2"];

    const zipColorMap = {};
    sortedProperties.forEach((p, idx) => {
      zipColorMap[p.zipcode] = fixedColors[idx % fixedColors.length];
    });

    const maxROI = Math.max(...sortedProperties.map((p) => p.roi || 0));
    const metrics = ["ROI (%)", "Appreciation (%)", "FLI"];
    let popupHeight = "auto";

    // --- Popup HTML ---
    let popupHTML = `
    <div class="compareOuter" style="position: relative;">
    
    <span id="popupToggleArrow"
      style="cursor: pointer; font-size: 20px; position: absolute; top: 10px; right: 50px; z-index: 10;">
    
      <img src="/assets/arrow-small-up.png" alt="Toggle" style="width: 20px; height: 20px;" />
    </span>
      <button class="popup-close-button" style="position: absolute; top: 30px; right: 20px;" id="compare-close-btn">&times;</button>

      <h4>Compare</h4>
      <div style="text-align:center; margin-bottom:10px; font-size:14px; color:#555;">
            ${sortedProperties
              .map(
                (p, idx) => `
                   <span style="
                    display:inline-block;
                    width:10px;
                    height:10px;
                    background-color:${fixedColors[idx % fixedColors.length]};
                    margin-right:2px;
                    border-radius:3px;
                  "></span>
                  ${p.zipcode}
               
                `
              )
              .join("")}
        </div>
      <!-- Accordion 1: ROI / Appreciation / FLI -->
      <div class="accordion-item expanded" id="accordion-metrics"
           style="border-bottom:1px solid #3d3d3d; margin-bottom:8px; overflow:hidden;background:transparent !important;
">
        <div class="accordion-header">
          <span><h6>ROI & Appreciation</h6></span><span>▲</span>
        </div>
        <div class="accordion-content" style="display:block; padding:10px;  background: #dcedeb;">
          <canvas id="chart-metrics" height="250"></canvas>
        </div>
      </div>

      <!-- Accordion 2: Sales Price -->
      <div class="accordion-item expanded" id="accordion-sales"
           style="border-bottom:1px solid #3d3d3d; margin-bottom:8px; overflow:hidden; background: #dcedeb;">
        <div class="accordion-header">
          <span><h6>Avg Home Value History</h6></span><span>▲</span>
        </div>
        <div class="accordion-content" style="display:block; padding:10px;  background: #dcedeb;">
          <canvas id="chart-sales" height="250"></canvas>
        </div>
      </div>

      <!-- Accordion 3: Comparison Table -->
      <div class="accordion-item expanded" id="accordion-table"
           style=" margin-bottom:8px; overflow:hidden">
        <div class="accordion-header">
          <span><h6>Zipcode Data Grid</h6></span><span>▲</span>
        </div>
        <div class="accordion-content" style="display:block; padding:10px;background: #dcedeb;">
          <table class="compare_tbl" border="0" cellpadding="8" cellspacing="0" style="width:100%; border-collapse:collapse; text-align:center;">
            <thead>
              <tr>
                <th class="metrics">Metric</th>
                ${sortedProperties
                  .map(
                    (p, idx) => `
                   <th style="background-color:transparent; font-weight:${
                     p.zipcode === selectedZip ? "bold" : "normal"
                   };">
                  <span style="
                    display:inline-block;
                    width:10px;
                    height:10px;
                    background-color:${fixedColors[idx % fixedColors.length]};
                    margin-right:2px;
                    border-radius:3px;
                  "></span>
                  ${p.zipcode}
                </th>
                `
                  )
                  .join("")}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="metrics">ROI</td>
                ${sortedProperties
                  .map((p) => {
                    const isMax = p.roi === maxROI;
                    // const style = `background-color:${zipColorMap[p.zipcode]}; ${isMax ? "font-weight:bold;" : ""}`;
                    const style = `color:${zipColorMap[p.zipcode]}; ${
                      isMax ? "font-weight:bold;" : ""
                    }`;
                    return `<td style="${style}">${p.roi}%</td>`;
                  })
                  .join("")}
              </tr>
              <tr>
                <td class="metrics">FLI</td>
                ${sortedProperties
                  .map(
                    (p, idx) =>
                      `<td style="color:${
                        fixedColors[idx % fixedColors.length]
                      };">${p.score}</td>`
                  )
                  .join("")}
              </tr>
              <tr>
                <td class="metrics">Appreciation</td>
                ${sortedProperties
                  .map(
                    (p, idx) =>
                      `<td style="color:${
                        fixedColors[idx % fixedColors.length]
                      };">${p.appreciation}%</td>`
                  )
                  .join("")}
              </tr>
              <tr>
                <td class="metrics">Sales</td>
                ${sortedProperties
                  .map(
                    (p, idx) =>
                      `<td style="color:${
                        fixedColors[idx % fixedColors.length]
                      };">${formatCurrency(p.sales || 0)}</td>`
                  )
                  .join("")}
              </tr>
              <tr>
                <td class="metrics">Rent</td>
                ${sortedProperties
                  .map(
                    (p, idx) =>
                      `<td style="color:${
                        fixedColors[idx % fixedColors.length]
                      };">${formatCurrency(p.rent || 0)}</td>`
                  )
                  .join("")}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `;

    document.getElementById("detailed_popup").innerHTML = popupHTML;
    const outerPopup = document.getElementById("detailed_popup");
    const arrowEl = document.getElementById("popupToggleArrow");

    // Add click event to toggle arrow rotation
if (arrowEl) {
  arrowEl.addEventListener("click", () => {
    arrowEl.classList.toggle("active");
  });
}

    // Toggle height on click
    arrowEl.addEventListener("click", function () {
      if (outerPopup.style.maxHeight === "100vh") {
        outerPopup.style.maxHeight = "150px"; // collapse
      } else {
        outerPopup.style.maxHeight = "100vh"; // expand
        outerPopup.style.height = "auto";
      }
    });

    // Initialize both charts immediately (default open)
    initMetricChart(sortedProperties, metrics, zipColorMap);
    initSalesChart(compareList, fixedColors);

    const accordionColors = {
      "accordion-metrics": { open: "#EBFFFD", closed: "#EBFFFD" }, // light blue
      "accordion-sales": { open: "#D6FFFB", closed: "#EBFFFD" }, // light green

      // "accordion-bar":     { open: "#FFF3E0", closed: "#ffffff" }, // light orange
      "accordion-table": { open: "#EBFFFD", closed: "#EBFFFD" }, // light purple
    };
    // Accordion toggle logic (multiple open allowed)
    document.querySelectorAll(".accordion-header").forEach((header) => {
      header.addEventListener("click", () => {
        const item = header.parentElement;
        const content = item.querySelector(".accordion-content");
        const expanded = content.style.display === "block";
        const id = item.id;
        if (expanded) {
          content.style.display = "none";
          // item.style.background = "#ebffd";
          item.style.color = "#3d3d3d";
          // item.style.background = accordionColors[id]?.closed || "#fff";
          // header.querySelector("span:last-child").innerText = "+";
          // header.querySelector("span:last-child").innerHTML = ` <i class="fas fa-chevron-down" style="color:gray;"></i>`;
          header.querySelector("span:last-child").innerText = "▼";
        } else {
          content.style.display = "block";
          // item.style.background = "#f0f8ff";
          // item.style.background = "#EBFFFD";
          // item.style.background = accordionColors[id]?.open || "#f0f8ff";
          item.style.color = "#3d3d3d";
          // header.querySelector("span:last-child").innerText = "-";
          // header.querySelector("span:last-child").innerHTML =  ` <i class="fas fa-chevron-up" style="color:gray;"></i>`;
          header.querySelector("span:last-child").innerText = "▲";

          // // Re-init charts if reopened
          // if (item.id === "accordion-metrics") {
          //   if (window.metricChartInstance) window.metricChartInstance.destroy();
          //   initMetricChart(sortedProperties, metrics, zipColorMap);
          // }
          // if (item.id === "accordion-sales") {
          //   if (window.salesChartInstance) window.salesChartInstance.destroy();
          //   initSalesChart(compareList, fixedColors);
          // }
          // Lazy init to avoid destroy issues

          // if (item.id === "accordion-bar" && !window.barChartInstance) {
          //   initBarChart(sortedProperties);
          // }
          // if (item.id === "accordion-sales" && !window.salesChartInstance) {
          //   initSalesChart(compareList, fixedColors);
          // }
        }
      });
    });

    // Close button
    const closeBtn = document.getElementById("compare-close-btn");
    if (closeBtn) {
      closeBtn.onclick = () => {
        document.getElementById("detailed_popup").style.display = "none";
        setPopupHTML(null);
      };
    }
  };

  // --- Chart Initializers ---
  function initBarChart(sortedProperties) {
    const zipcodes = sortedProperties.map((p) => p.zipcode);
    const fliData = sortedProperties.map((p) => p.score);
    const roiData = sortedProperties.map((p) => p.roi);
    const apprData = sortedProperties.map((p) => p.appreciation);

    const ctx = document.getElementById("popupChartBar").getContext("2d");
    if (window.barChartInstance) window.barChartInstance.destroy();

    window.barChartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels: zipcodes,
        datasets: [
          { label: "ROI (%)", data: roiData, backgroundColor: "#8e5ea2" },
          {
            label: "Appreciation (%)",
            data: apprData,
            backgroundColor: "#3cba9f",
          },
          { label: "FLI", data: fliData, backgroundColor: "#3e95cd" },
        ],
      },
      options: { responsive: true, maintainAspectRatio: false },
    });
  }

  // Metric Chart initializer
  function initMetricChart(sortedProperties, metrics, zipColorMap) {
    console.log("sortedProperties: ***********", sortedProperties);
    const ctx = document.getElementById("chart-metrics")?.getContext("2d");
    if (!ctx) return;

    new Chart(ctx, {
      type: "bar",
      data: {
        labels: metrics,
        datasets: sortedProperties.map((p) => ({
          label: p.zipcode,
          data: [p.roi || 0, p.appreciation || 0, p.score || 0],
          backgroundColor: zipColorMap[p.zipcode],
        })),
      },
      options: {
        responsive: true,
         indexAxis: 'x',
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (tooltipItem) =>
                `${tooltipItem.dataset.label}: ${tooltipItem.raw}`,
            },
          },
        },
        scales: {
          x: { title: { display: true, text: "Metric" } },
          y: { beginAtZero: true, title: { display: true, text: "Value" } },
        },
      },
    });
  }

  // Sales Chart initializer
  function initSalesChart(compareList, fixedColors) {
    // ...inside showCompareDetails...
console.log("CompareList: ***********", compareList);
// console.log("OriginalPropertyList:", originalPropertyList);
// console.log("SortedProperties:", sortedProperties);
    const canvas = document.getElementById("chart-sales");
    if (!canvas) return;

    const url = `https://beta.flowlogic.com/api/compare?zipcodes=${compareList.join(
      ","
    )}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((r) => r.json())
      .then((data) => {
        const latestYear = data?.compare?.[0]?.last_updated_sales_year || 2025;
        const years = Array.from({ length: 4 }, (_, i) =>
          String(latestYear - 3 + i)
        );
        const fieldMap = {
          [years[0]]: "sales_data_three",
          [years[1]]: "sales_data_two",
          [years[2]]: "sales_data_one",
          [years[3]]: "avg_current_sales",
        };

        const datasets = data.compare.map((entry, index) => ({
          label: `${entry.zip}`,
          data: years.map((year) => parseFloat(entry[fieldMap[year]]) || 0),
          borderWidth: 2,
          fill: false,
          tension: 0.3,
          borderColor: fixedColors[index % fixedColors.length],
          backgroundColor: fixedColors[index % fixedColors.length],
        }));

        new Chart(canvas.getContext("2d"), {
          type: "line",
          data: { labels: years, datasets },
          options: {
            responsive: true,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: (tooltipItem) =>
                    `${tooltipItem.dataset.label}: ${formatCurrency(
                      tooltipItem.raw
                    )}`,
                },
              },
            },
            scales: {
              x: { title: { display: true, text: "Year" } },
              y: {
                title: { display: true, text: "Sales Price ($)" },
                ticks: { callback: (v) => formatCurrency(v) },
              },
            },
          },
        });
      });
  }

  // const showCompareDetails1 = (compareList, originalPropertyList) => {
  //   //console.log("compare properties", originalPropertyList);

  //   const matchedProperties = originalPropertyList.filter((property) =>
  //     compareList.includes(property.zipcode)
  //   );

  //   const selectedZip = selectedZipcode; // Ensure this is globally defined or passed in

  //   const zipOrder = [
  //     selectedZip,
  //     ...compareList.filter((zip) => zip !== selectedZip),
  //   ];

  //   const sortedProperties = zipOrder
  //     .map((zip) => matchedProperties.find((p) => p.zipcode === zip))
  //     .filter(Boolean); // removes any undefined values if zip not found
  //   const maxROI = Math.max(...sortedProperties.map((p) => p.roi || 0));
  //   // const fixedColors = ['#fffbb9', '#8e5ea2', '#3cba9f', '#e8c3b9']; // Fixed color set
  //   const fixedColors = ["#fdf796", "#8e5ea2", "#EC7357", "#a0a7be"];
  //   const zipColorMap = {};
  //   sortedProperties.forEach((p, index) => {
  //     zipColorMap[p.zipcode] = fixedColors[index % fixedColors.length];
  //   });

  //   let popupHTML = `

  //             <div class="compareOuter"  style="position: relative;">
  //                 <button class="popup-close-button" id="compare-close-btn" style="
  //     position: absolute;
  //     top: 10px;
  //     right: 10px;
  //     // background: #fff;
  //     border: none;
  //     font-size: 22px;
  //     cursor: pointer;
  //     z-index: 10;
  //     border-radius: 50%;
  //     width: 32px;
  //     height: 32px;
  //     box-shadow: 0 2px 6px rgba(221, 224, 221, 0.1);
  //   ">&times;</button>
  //   <span id="popupToggleArrow"
  //         style="cursor: pointer; font-size: 20px; position: absolute; top: 10px; right: 50px; z-index: 10;width:18px">
  //     <img
  //           src="/assets/expand.svg"
  //         />
  //   </span>
  //               <h4>Compare & Choose</h4>

  //               <h6>ROI & Appreciation Analysis</h6>
  //                <div class="popup-content"><canvas id="popupChartBar" width="300" height="300"></canvas></div>
  //                 <h6>Sales Price Analysis</h6>
  //               <div class="popup-content" style="margin-top: 10px;">
  //                   <canvas id="popupChartList" width="300" height="250"></canvas>
  //               </div>
  //               <table class="compare_tbl" border="0" cellpadding="8" cellspacing="0" style="width: 100%; border-collapse: collapse; text-align: center;">
  //                 <thead>
  //                   <tr>
  //                     <th class="metrics">Metric</th>
  //                     ${sortedProperties
  //                       .map(
  //                         (p) => `
  //                      <th style="background-color: ${
  //                        zipColorMap[p.zipcode]
  //                      };  font-weight: ${
  //                           p.zipcode === selectedZip ? "bold" : "normal"
  //                         };">
  //                       ${p.zipcode}${p.zipcode === selectedZip ? "" : ""}
  //                       </th>`
  //                       )
  //                       .join("")}
  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   <tr>
  //                   <td class="metrics">ROI</td>
  //                   ${sortedProperties
  //                     .map((p) => {
  //                       const isMax = p.roi === maxROI;
  //                       const style = `background-color: ${
  //                         zipColorMap[p.zipcode]
  //                       };  ${isMax ? "font-weight: bold;" : ""}`;
  //                       return `<td style="${style}">${p.roi}%</td>`;
  //                     })
  //                     .join("")}
  //                   </tr>
  //                 <tr>
  //                   <td class="metrics">FLI</td>
  //                   ${sortedProperties
  //                     .map((p, idx) => {
  //                       const color = fixedColors[idx % fixedColors.length];
  //                       return `<td style="background-color: ${color}; ">${p.score}</td>`;
  //                     })
  //                     .join("")}
  //                   </tr>
  //                   <tr>
  //                   <td class="metrics">Appreciation</td>
  //                   ${sortedProperties
  //                     .map((p, idx) => {
  //                       const color = fixedColors[idx % fixedColors.length];
  //                       return `<td style="background-color: ${color}; ">${p.appreciation}%</td>`;
  //                     })
  //                     .join("")}
  //                   </tr>
  //                   <tr>
  //                   <td class="metrics">Sales</td>
  //                   ${sortedProperties
  //                     .map((p, idx) => {
  //                       const color = fixedColors[idx % fixedColors.length];
  //                       return `<td style="background-color: ${color}; ">${formatCurrency(
  //                         p.sales || 0
  //                       )}</td>`;
  //                     })
  //                     .join("")}
  //                   </tr>
  //                   <tr>
  //                   <td class="metrics">Rent</td>
  //                   ${sortedProperties
  //                     .map((p, idx) => {
  //                       const color = fixedColors[idx % fixedColors.length];
  //                       return `<td style="background-color: ${color}; ">${formatCurrency(
  //                         p.rent || 0
  //                       )}</td>`;
  //                     })
  //                     .join("")}
  //                   </tr>
  //                   </tbody>
  //               </table>

  //               <p style="margin-top: 10px; font-style: italic; color: #555;">
  //                 Selected ZIP (${selectedZip}) is shown as the reference column.
  //               </p>
  //             </div>
  //           `;

  //   document.getElementById("detailed_popup").innerHTML = popupHTML;

  //   const outerPopup = document.getElementById("detailed_popup");
  //   const arrowEl = document.getElementById("popupToggleArrow");

  //   // Toggle height on click
  //   arrowEl.addEventListener("click", function () {
  //     if (outerPopup.style.maxHeight === "100vh") {
  //       outerPopup.style.maxHeight = "150px"; // collapse
  //     } else {
  //       outerPopup.style.maxHeight = "100vh"; // expand
  //       outerPopup.style.height = "auto";
  //     }
  //   });
  //   setTimeout(() => {
  //     const closeBtn = document.getElementById("compare-close-btn");
  //     if (closeBtn) {
  //       closeBtn.onclick = () => {
  //         document.getElementById("detailed_popup").style.display = "none";
  //         setPopupHTML(null);
  //       };
  //     }
  //   }, 0);
  //   //console.log("compareList",compareList);
  //   setTimeout(() => {
  //     const canvas = document.getElementById("popupChartList");
  //     if (!canvas) return console.error("Chart canvas not found.");

  //     const url = `https://beta.flowlogic.com/api/compare?zipcodes=${compareList.join(
  //       ","
  //     )}`;
  //     //console.log('Fetching compare API:', url);

  //     fetch(url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         // const years = ['2021', '2022', '2023', '2024'];
  //         const latestYear =
  //           data?.compare?.[0]?.last_updated_sales_year || 2025;

  //         // Generate years dynamically from latestYear - 3 to latestYear
  //         const years = Array.from({ length: 4 }, (_, i) =>
  //           String(latestYear - 3 + i)
  //         );

  //         const fieldMap = {
  //           [years[0]]: "sales_data_three", // latestYear - 3
  //           [years[1]]: "sales_data_two", // latestYear - 2
  //           [years[2]]: "sales_data_one", // latestYear - 1
  //           [years[3]]: "avg_current_sales", // latestYear
  //         };

  //         const datasets = data.compare.map((entry, index) => ({
  //           label: `${entry.zip}`,
  //           data: years.map((year) => parseFloat(entry[fieldMap[year]]) || 0),
  //           borderWidth: 2,
  //           fill: false,
  //           tension: 0.3,
  //           borderColor: fixedColors[index % fixedColors.length],
  //           backgroundColor: fixedColors[index % fixedColors.length],
  //         }));

  //         const ctx1 = canvas.getContext("2d");
  //         new Chart(ctx1, {
  //           type: "line",
  //           data: {
  //             labels: years,
  //             datasets: datasets,
  //           },
  //           options: {
  //             responsive: true,
  //             maintainAspectRatio: false,
  //             plugins: {
  //               legend: {
  //                 display: true,
  //                 labels: {
  //                   usePointStyle: true, // Use point style instead of line
  //                   pointStyle: "rectRounded", // Use filled square (can also try 'circle', 'rect', etc.)
  //                   boxWidth: 15, // Width of legend box
  //                   boxHeight: 15, // Height of legend box
  //                   padding: 20,
  //                 },
  //               },
  //               tooltip: {
  //                 callbacks: {
  //                   label: function (tooltipItem) {
  //                     return `${tooltipItem.dataset.label}: ${formatCurrency(
  //                       tooltipItem.raw
  //                     )}`;
  //                   },
  //                 },
  //               },
  //             },
  //             scales: {
  //               x: { title: { display: true, text: "Year" } },
  //               y: {
  //                 title: { display: true, text: "Sales Price ($)" },
  //                 ticks: {
  //                   callback: function (value) {
  //                     return formatCurrency(value);
  //                   },
  //                 },
  //               },
  //             },
  //           },
  //         });
  //       })
  //       .catch((error) => {
  //         console.error("Failed to fetch sales data for chart:", error);
  //       });
  //   }, 100); // Delay for canvas to render

  //   const zipcodes = sortedProperties.map((p) => p.zipcode);
  //   const fliData = sortedProperties.map((p) => p.score);
  //   const roiData = sortedProperties.map((p) => p.roi);
  //   const apprData = sortedProperties.map((p) => p.appreciation);

  //   const ctx = document.getElementById("popupChartBar").getContext("2d");

  //   new Chart(ctx, {
  //     type: "bar",
  //     data: {
  //       labels: zipcodes,
  //       datasets: [
  //         {
  //           label: "ROI (%)",
  //           data: roiData,
  //           backgroundColor: "#8e5ea2",
  //         },
  //         {
  //           label: "Appreciation (%)",
  //           data: apprData,
  //           backgroundColor: "#3cba9f",
  //         },
  //         {
  //           label: "FLI",
  //           data: fliData,
  //           backgroundColor: "#3e95cd",
  //         },
  //       ],
  //     },
  //     options: {
  //       responsive: true,
  //       maintainAspectRatio: false,
  //       plugins: {
  //         legend: { position: "top" },
  //         tooltip: {
  //           callbacks: {
  //             label: function (tooltipItem) {
  //               const val = tooltipItem.raw;
  //               return `${tooltipItem.dataset.label}: ${val}%`;
  //             },
  //           },
  //         },
  //       },
  //       scales: {
  //         x: {
  //           title: { display: true, text: "ZipCode" },
  //         },
  //         y: {
  //           title: { display: true, text: "Value" },
  //           beginAtZero: true,
  //         },
  //       },
  //     },
  //   });
  // };

  // useEffect(() => {
  //   fetch("https://beta.flowlogic.com/zip/favorite/all/", {
  //     headers: { Authorization: `Bearer ${authToken}` },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log("Fetched favorites:", data.favourites);
  //       setFavoriteZipcodes(data.favourites || []);
  //     })
  //     .catch((err) => console.error("Failed to load favorites", err));
  // }, []);

  // useEffect(() => {
  //   if (!mapRef.current || favoriteZipcodes.length === 0) return;

  //   // fetchFeatureData();
  //   debouncedFetchFeatureData(); // Use the debounced function to avoid too many calls
  // }, [favoriteZipcodes]);

  
  useEffect(() => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
  if (isMobile) {
    setCurrentView("list"); // Set initial view to list on mobile
  }
}, []);

// const handleResetFLI = () => {
//   // Add your reset logic here
//   setShowFLISection(false); // Or reset other related state
// };

const handleResetFLI = async () => {
  const defaultROI = 70;
  const defaultAppreciation = 30;

  // Update local state
  setRoiFilterTemp(defaultROI);
  setAppreciationFilterTemp(defaultAppreciation);
  setFliROIFilter(defaultROI);
  setFliApprFilter(defaultAppreciation);
  setApplyClicked(false);
  setIncludeAdditionalFeatures(false);

  // Save to local storage
  localStorage.setItem("fliROIFilter", defaultROI);
  localStorage.setItem("fliApprFilter", defaultAppreciation);

  console.log("Reset to defaults: ROI 70%, Appreciation 30%");

  // Normalize for API
  const roiNormalized = defaultROI / 100;
  const apprNormalized = defaultAppreciation / 100;

  try {
    const response = await fetch(
      "https://beta.flowlogic.com/api/users/preference/update/",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          roi_weightage: roiNormalized,
          appr_weightage: apprNormalized,
        }),
      }
    );

    console.log("API Endpoint: https://beta.flowlogic.com/api/users/preference/update");
    console.log("Sent Payload:", {
      roi_weightage: roiNormalized,
      appr_weightage: apprNormalized,
    });
    console.log("Response Status:", response.status);

    const data = await response.json();
    console.log("Response JSON:", data);
      toast.success("FLI set to default");

    if (!response.ok) {
      throw new Error(`Server responded with status ${response.status}`);
    }

    console.log("Preferences saved successfully.");
  } catch (err) {
    console.error("Failed to update preferences:", err);
  }
};



  const fetchFeatureData = () => {
    console.log("fetchFeatureData called");
    const map = mapRef.current;
    const source = map.getSource("vector-tiles");
    if (!source || !map.isSourceLoaded("vector-tiles")) return;

    const features = map.queryRenderedFeatures({ layers: ["point-layer"] });
    console.log("features", features);
    if (!features || features.length === 0) {
      console.warn("No features found");
      return;
    } else {
      console.log("Features found:", features.length);
    }
    const seen = new Set();
    const uniqueData = [];

    for (const feature of features) {
      const { zipcode, roi, appreciation, score, sales, state, city, rent } =
        feature.properties;
      const [lon, lat] = feature.geometry.coordinates;
      const modifiedROI = parseInt(feature.properties.roi, 10);
      const modifiedAppreciation = parseInt(
        feature.properties.appreciation,
        10
      );
      if (!seen.has(zipcode)) {
        seen.add(zipcode);
        //   const isFavorite = favoriteZipcodes.includes(zipcode);
        // const favorite = favoriteZipcodes.includes(String(zipcode)); // Use String to be safe

        // console.log(typeof zipcode, typeof favoriteZipcodes[0]);
        // console.log("typeof zipcode, typeof favoriteZipcodes[0]");
        // console.log(typeof zipcode, typeof favoriteZipcodes);

        // console.log('Checking zip:', zipcode);
        // console.log('All favorite zips:', favoriteZipcodes);
        // console.log('Is favorite?', favorite);

        uniqueData.push({
          zipcode,
          roi: modifiedROI,
          latitude: lat,
          longitude: lon,
          appreciation: modifiedAppreciation,
          score,
          sales,
          state,
          city,
          rent,
          rawroi:feature.properties.roi,
          rawappreciation:feature.properties.appreciation,
          //favorite: favoriteZipcodes.includes(String(zipcode)),
        });
      }
    }

    // Sort by ROI in descending order (high ROI on top)
    uniqueData.sort((a, b) => b.roi - a.roi);

    // Calculate min and max sales values from the data
    const salesValues = uniqueData.map((property) => property.sales);
    const minSalesValue = Math.min(...salesValues); // Find the minimum sales value
    const maxSalesValue = Math.max(...salesValues); // Find the maximum sales value

    setMinSales(minSalesValue); // Set the min sales value
    setMaxSales(maxSalesValue); // Set the max sales value
    setSliderMinSales(minSalesValue); // Set the min sales value
    setSliderMaxSales(maxSalesValue); // Set the max sales value

    // const userAgent = window.navigator.userAgent.toLowerCase();
    //     const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
    //     if (isMobile) {
    //       setCurrentView("list");
    //     }
    setOriginalPropertyList(uniqueData); // Store the original list of properties
    // After building uniqueData or properties
    // console.log("originalPropertyList", uniqueData);
    // After building uniqueData or properties
    // console.log("originalPropertyList", uniqueData);

    setPropertyList(uniqueData);
  };

  const handleUpgrade = async () => {
    console.log("button clicked");
    try {
      //   const response = await fetch('http://flowmap.uvjtech.in/api/users/subscription/add/', {
      const response = await fetch(
        "https://beta.flowlogic.com/api/users/subscription/add/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) throw new Error("Subscription failed");

      if (response.ok) {
        localStorage.setItem("isSubscribed", "true");
        setIsSubscribed(true);

        //   alert("You have successfully upgraded to a paid user");
        toast.success("You have successfully upgraded to a paid user");
        window.location.reload();
      } else {
        const data = await response.json();
        console.error("Upgrade failed:", data.message || "Unknown error");
      }
    } catch (error) {
      console.error("Network error during upgrade:", error);
    }
  };

  const handleLogout = () => {
    // Remove authToken from localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("otp");
    localStorage.setItem("isSubscribed", "false");
    localStorage.removeItem("subscriptionType");
    localStorage.removeItem("paymentDate");

    // Optional: If you're using a global state (like context or redux), you may want to clear that as well
    // Example with context (if applicable):
    // dispatch({ type: 'LOGOUT' });

    // Redirect user to login page or home page
    window.location.href = "/"; // or use a router if you're using react-router
  };
  useEffect(() => {
    if (!mapRef.current || !mapRef.current.getLayer("point-layer")) return;

    const filters = ["all"];

    if (activeTab === "favorites" && favoriteZipcodes.length > 0) {
      filters.push(["in", ["get", "zipcode"], ["literal", favoriteZipcodes]]);
    }

    if (roiFilter !== "All") {
      filters.push([">=", ["get", "roi"], roiFilter]);
    }

    if (appreciationFilter !== "All") {
      filters.push([">=", ["get", "appreciation"], appreciationFilter]);
    }

    if (scoreFilter !== "All") {
      filters.push([">=", ["get", "score"], scoreFilter]);
    }

    mapRef.current.setFilter(
      "point-layer",
      filters.length > 1 ? filters : null
    );
  }, [activeTab, favoriteZipcodes, roiFilter, appreciationFilter, scoreFilter,crimeIndexFilter]);

   const userAgent = window.navigator.userAgent.toLowerCase();
  const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
///fav list constant
  // const filteredList = propertyList.filter(property => !currentStateId || property.state === currentStateId);
  let filteredList = propertyList.filter(
    (property) =>
      (!currentStateId || property.state === currentStateId) &&
      (!currentCity || property.city === currentCity)
  );
 filteredList = activeTab === "favorites" ? updatedFavoritePropertyList : filteredList;
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <Header
          activeTab={activeTab}
          handleTabChange={handleTabChange}
          toggleMenu={toggleMenu}
          isMenuOpen={isMenuOpen}
          handleLogout={handleLogout}
          geocoderContainerRef={geocoderContainerRef}
          showSearch={true}
          showFavorites={true}
          showLinks={true}
          handleUpgrade={handleUpgrade}
          isSubscribed={isSubscribed}
        />
      {/* <div style={{ padding: "10px", display: "flex", alignItems: "center" }}>
        <label style={{ marginRight: "10px", fontWeight: 600 }}>
          View: Property
        </label>

        <span
          role="link"
          tabIndex={0}
          onClick={() => navigate("/parcels")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") navigate("/parcels");
          }}
          style={{
            cursor: "pointer",
            color: "#1c8f7d",
            textDecoration: "underline",
            fontWeight: 600,
            padding: "6px 8px",
            borderRadius: 4,
            background: "transparent",
            marginLeft: 8,
          }}
          title="Go to Parcels page"
        >
          View Land / Parcels
        </span>
      </div> */}
      

        <div className="subHeaderOuter">
          {activeTab === "all" ? (
            <div className="filter-wrapper">
              {/* Toggle Icon for Mobile */}
              <div className="mobile-filter-toggle">
                <FilterListIcon
                  onClick={() => setShowMobileFilters(!showMobileFilters)}
                />
                {activeFilterCount > 0 && (
                  <div className="filter-count-badge">{activeFilterCount}</div>
                )}
              </div>
              {(showMobileFilters || window.innerWidth > 768) && (
                <div
                  className={`filterOuter ${showMobileFilters ? "show" : ""}`}
                >
                  <div className="priceOuter">
                    <Button
                      variant="contained"
                      color="primary filter-button"
                      className={`filter-button ${
                        showPriceFilter  || minSales !== sliderMinSales || maxSales !== sliderMaxSales ? "filterOuteractive" : ""
                      }`} // Conditionally apply 'filterOuteractive'
                      endIcon={<ArrowDropDownIcon />}

                      onClick={() => {
                        setShowROIFilter(false); // Close the ROI ButtonGroup
                        setShowAppreciationFilter(false); // Close the Appreciation ButtonGroup
                        setShowScoreFilter(false); // Close the Score ButtonGroup
                        setShowPriceFilter(!showPriceFilter);
                      }}
                    >
                      {"Sales Value"}
                    </Button>
                    {/* Price Range Slider */}
                    {(showPriceFilter || window.innerWidth <= 768) && (
                      <div className="price-filter-container">
                        <ReactSlider
                          className="horizontal-slider"
                          thumbClassName="example-thumb"
                          trackClassName="example-track"
                          value={[minSales, maxSales]} // Bind state values for the slider
                          onChange={handlePriceSliderChange} // Update the state when slider values change
                          min={sliderMinSales} // Set the min value for the slider
                          max={sliderMaxSales} // Set the max value for the slider
                          step={1} // Step value for each movement
                          pearling={true} // Smooth pearling behavior
                          minDistance={10} // Minimum distance between the two thumbs
                          ariaLabel={["Lower thumb", "Upper thumb"]} // Accessibility labels
                          ariaValuetext={(state) =>
                            `Thumb value ${Math.round(state.valueNow)}`
                          } // Accessibility text for thumb value
                          renderThumb={(props, state) => (
                            <div {...props}>
                              {/* // {Math.round(state.valueNow)} Display the value of the thumb */}
                            </div>
                          )}
                        />

                        {/* Optional: Labels for the min and max values */}
                        <div className="slider-labels">
                          <span className="min-label">
                            Min: {formatCurrency(minSales)}
                          </span>
                          <span className="max-label">
                            Max: {formatCurrency(maxSales)}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <Button
                    variant="contained"
                    color="primary filter-button"
                    className={`filter-button ${
                      (showROIFilter || roiFilter !=="All" )? "filterOuteractive" : ""
                    }`} // Conditionally apply 'filterOuteractive'
                    endIcon={<ArrowDropDownIcon />}
                    onClick={() => {
                      setShowROIFilter(!showROIFilter);
                      setShowAppreciationFilter(false); // Close the Appreciation ButtonGroup
                      setShowScoreFilter(false); // Close the Score ButtonGroup
                      setShowPriceFilter(false);
                    }}
                  >
                    {roiFilter === "All"
                      ? "ROI"
                      : roiFilter !== null
                      ? `ROI - ${roiFilter}%`
                      : "ROI"}{" "}
                    {/* Display "ROI - All" if roiFilter is 0 */}
                    {(showROIFilter || window.innerWidth <= 768) && (
                      <div className="slider-container roi_slider">
                        <ButtonFilter
                          filterType="roi"
                          selectedValue={roiFilter}
                          onClick={handleSliderChange}
                        />
                      </div>
                    )}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary filter-button"
                    endIcon={<ArrowDropDownIcon />}
//                                           endIcon={
//   <img
//     src="/assets/arrow-small-up.png" // path relative to public folder
//     alt="Dropdown"
//     style={{ width: 20, height: 20 }}
//   />
// }
                    className={`filter-button ${
                      (showAppreciationFilter || appreciationFilter !=="All")? "filterOuteractive" : ""
                    }`} // Conditionally apply 'filterOuteractive'
                    onClick={() => {
                      setShowROIFilter(false); // Close the ROI ButtonGroup
                      setShowAppreciationFilter(!showAppreciationFilter);
                      setShowScoreFilter(false); // Close the Score ButtonGroup
                      setShowPriceFilter(false);
                    }}
                  >
                    {appreciationFilter === "All"
                      ? "Appreciation"
                      : appreciationFilter !== null
                      ? `Appreciation - ${appreciationFilter}%`
                      : "Appreciation"}
                    {(showAppreciationFilter || window.innerWidth <= 768) && (
                      <div className="slider-container appr_slider">
                        <ButtonFilter
                          filterType="appreciation"
                          selectedValue={appreciationFilter}
                          onClick={handleSliderChange}
                        />
                      </div>
                    )}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary filter-button"
                    className={`filter-button ${
                    showScoreFilter || scoreFilter !== "All" ? "filterOuteractive" : ""
                  }`}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={() => {
                      setShowROIFilter(false); // Close the ROI ButtonGroup
                      setShowAppreciationFilter(false); // Close the Appreciation ButtonGroup
                      setShowScoreFilter(!showScoreFilter);
                      setShowPriceFilter(false);
                    
                    }}
                  >

                    {scoreFilter === "All"
                      ? "FLI"
                      : scoreFilter !== null
                      ? `FLI - ${scoreFilter}`
                      : "FLI"}{" "}
</Button>
                    {(showScoreFilter || window.innerWidth <= 768) && (
                      <div className="slider-container score_slider">
                        <ButtonFilter
                          filterType="score"
                          selectedValue={scoreFilter}
                          onClick={handleSliderChange}
                        />
                      <div style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "8px",
  marginBottom: "8px"
}}>
                      <label style={{ fontWeight: "bold", display: "block", marginBottom: "8px",marginTop:"8px" }}>
  <input
    type="checkbox"
    checked={showFLISection}
    onChange={e => setShowFLISection(e.target.checked)}
    style={{ marginRight: "8px" ,marginTop: "10px",paddingTop:"10px"}}
  />
   Customize FLI
</label>

 {showFLISection && (
    <button
      onClick={handleResetFLI}
      title="Reset"
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "4px",
        display: "flex",
        alignItems: "center"
      }}
    >
      <RestartAltIcon style={{ color: "#555" }} />
    </button>
  )}
                      </div>
{showFLISection && (
                     <div style={{ padding: "10px" }}>
  {/* ROI Slider */}
  <div style={{ marginBottom: "20px" }}>
    <label style={{ fontWeight: "normal", display: "block" }}>ROI (%)</label>
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* <span style={{ fontSize: "12px", marginRight: "8px" }}>0%</span> */}
      <ReactSlider
        className="horizontal-slider"
        thumbClassName="example-thumb"
        trackClassName="fli-track"
        value={roiFilterTemp}
             onChange={(val) => {
          setRoiFilterTemp(val);
          // setAppreciationFilterTemp(100 - val); // Keep sum 100
          //  setAppreciationFilterTemp(100 - additionalFeatureWeight - val);
            setAppreciationFilterTemp(includeAdditionalFeatures ? 100 - additionalFeatureWeight -val: 100-val);
        }}
        min={0}
        // max={100}
          // max={100 - additionalFeatureWeight}
          max={includeAdditionalFeatures ? 100 - additionalFeatureWeight : 100}
        step={1}
        style={{ flexGrow: 1 }}
      />
       <span style={{ marginLeft: "12px", fontWeight: "bold" }}>{roiFilterTemp}%</span>
      {/* <span style={{ fontSize: "12px", marginLeft: "8px" }}>100%</span> */}
    </div>
    {/* <div style={{ textAlign: "center", marginTop: "4px" }}>
      {roiFilterTemp}%
    </div> */}
  </div>

  {/* Appreciation Slider */}
  <div style={{ marginBottom: "20px" }}>
    <label style={{ fontWeight: "normal", display: "block" }}>Appreciation (%)</label>
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* <span style={{ fontSize: "12px", marginRight: "8px" }}>0%</span> */}
      <ReactSlider
        className="horizontal-slider"
        thumbClassName="example-thumb"
        trackClassName="fli-track"
        value={appreciationFilterTemp}
               onChange={(val) => {
          setAppreciationFilterTemp(val);
          // setRoiFilterTemp(100 - val); // Keep sum 100
          //  setRoiFilterTemp(100 - additionalFeatureWeight - val);
            setRoiFilterTemp(includeAdditionalFeatures ? 100 - additionalFeatureWeight -val: 100-val);

        }}
        min={0}
        // max={100}
          // max={100 - additionalFeatureWeight}
          max={includeAdditionalFeatures ? 100 - additionalFeatureWeight : 100}
        step={1}
        style={{ flexGrow: 1 }}
      />
      {/* <span style={{ fontSize: "12px", marginLeft: "8px" }}>100%</span> */}
       <span style={{ marginLeft: "12px", fontWeight: "bold" }}>{appreciationFilterTemp}%</span>
    </div>
    {/* <div style={{ textAlign: "center", marginTop: "4px" }}>
      {appreciationFilterTemp}%
    </div> */}
  </div>

  {/* <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
  <span>ROI: {roiFilterTemp}%</span>
  <span>Appreciation: {appreciationFilterTemp}%</span>
  {includeAdditionalFeatures && (
    <span>Additional Features: {additionalFeatureWeight}%</span>
  )}
</div> */}




{/* <div style={{ marginBottom: "20px", padding: "5px", borderRadius: "8px" }}>
  <label style={{ fontWeight: "bold", display: "block", marginBottom: "8px" }}>
    <input
      type="checkbox"
      checked={includeAdditionalFeatures}
      onChange={(e) => {
        const checked = e.target.checked;
        setIncludeAdditionalFeatures(checked);
        setAdditionalFeatureList((prev) =>
          prev.map((f) => ({ ...f, enabled: checked }))
        );
      }}
      style={{ marginRight: "8px" }}
    />
   Additional Features in FLI
  </label>
  {includeAdditionalFeatures && (
    <div style={{ marginTop: "10px", borderTop: "1px solid #ccc", paddingTop: "10px" }}>
      <div style={{ marginBottom: "10px", padding: "10px 0px",diaplay:"flex", alignItems:"center"
 }}>
     
          <ReactSlider
            className="horizontal-slider"
        thumbClassName="example-thumb"
        trackClassName="fli-track"
            value={additionalFeatureWeight}
            onChange={setAdditionalFeatureWeight}
            min={0}
            max={20}
            step={1}
            style={{        
  
          width: "100%",
          display: "inline-block",
          background: "#e0f7e9", 
          borderRadius: "8px",
         }}
          />
 
            <span style={{  fontWeight: "bold" }}>
      Weight: {additionalFeatureWeight}%
    </span>
      </div>
      {additionalFeatureList.map((feature, idx) => (
        <div key={feature.key} style={{ margin: "0px 5px 10px 5px" }}>
          <label style={{ fontWeight: "normal"}}>
            <input
              type="checkbox"
              checked={feature.enabled}
              onChange={() => {
                const updated = additionalFeatureList.map((f, i) =>
                  i === idx ? { ...f, enabled: !f.enabled } : f
                );
                setAdditionalFeatureList(updated);
        
                if (updated.every((f) => !f.enabled)) {
                  setIncludeAdditionalFeatures(false);
                }
              }}
              style={{ marginRight: "8px" ,fontWeight:'normal'}}
            />
            {feature.label}
          </label>
          {feature.enabled && (
             <div style={{ display: "flex", alignItems: "center" }}>
            <ReactSlider
              className="horizontal-slider"
              thumbClassName="example-thumb"
              trackClassName="fli-track"
              value={feature.weight}

onChange={(val) => {
  setAdditionalFeatureList((prev) => {

    const enabledIndexes = prev
      .map((f, i) => (f.enabled && i !== idx ? i : null))
      .filter((i) => i !== null);

  
    const sumOthers = enabledIndexes.reduce((sum, i) => sum + prev[i].weight, 0);


    let maxAllowed = additionalFeatureWeight;
    if (val + sumOthers > maxAllowed && enabledIndexes.length > 0) {
      const excess = val + sumOthers - maxAllowed;

      let newPrev = [...prev];
      let totalOther = sumOthers;
      enabledIndexes.forEach((i) => {
        const oldWeight = prev[i].weight;
        const reduction = Math.round((oldWeight / totalOther) * excess);
        newPrev[i] = {
          ...prev[i],
          weight: Math.max(0, oldWeight - reduction),
        };
      });

      newPrev[idx] = { ...prev[idx], weight: val };
      return newPrev;
    } else {

      return prev.map((f, i) =>
        i === idx ? { ...f, weight: val } : f
      );
    }
  });
}}


              min={0}
              max={additionalFeatureWeight}
              step={1}
              style={{ marginLeft: "16px", width: "120px", display: "inline-block" }}
            />
                   <span style={{ marginLeft: "12px", fontWeight: "bold" }}>
          {feature.weight}%
        </span>
      </div>
            
          )}
    
        </div>
      ))}
    </div>
  )}
</div> */}





  {/* Apply Button */}
{/* <div style={{ textAlign: "center" }}>
  <button
    style={{
      padding: "8px 16px",
      background: "#3d3d3d",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontWeight: "bold",
    }}
    onClick={async () => {
      setFliROIFilter(roiFilterTemp);
      setFliApprFilter(appreciationFilterTemp);
      setApplyClicked(true);


      localStorage.setItem("fliROIFilter", roiFilterTemp);
      localStorage.setItem("fliApprFilter", appreciationFilterTemp);


      const roiNormalized = roiFilterTemp / 100;
      const apprNormalized = appreciationFilterTemp / 100;

      try {
        console.log("ROI Temp:", roiFilterTemp);
console.log("Appreciation Temp:", appreciationFilterTemp);
console.log("Normalized ROI:", roiNormalized);
console.log("Normalized APP:", apprNormalized);

  if (
  typeof roiFilterTemp !== "number" ||
  typeof appreciationFilterTemp !== "number" ||
  isNaN(roiFilterTemp) ||
  isNaN(appreciationFilterTemp)
) {
  alert("⚠️ Please set valid values for ROI and Appreciation.");
  return;
}

        // Send PUT request to update preferences
        const response = await fetch(
          "https://beta.flowlogic.com/api/users/preference/update/",
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
              roi_weightage: roiNormalized,
              appr_weightage: apprNormalized,
            }),
          }
        );


        console.log("API Endpoint: https://beta.flowlogic.com/api/users/preference/update");
        console.log("Sent Payload:", {

        });
        console.log("Response Status:", response.status);

        const data = await response.json();
        console.log("Response JSON:", data);

        if (!response.ok) {
          throw new Error(`Server responded with status ${response.status}`);
        }

        console.log(" FLI preferences updated successfully.");
      } catch (err) {
        console.error(" Failed to update preferences:", err);
      }
    }}
  >
    Apply
  </button>
</div> */}


<div style={{ textAlign: "center", marginTop: "20px", }}>
  <div style={{ display: "flex",  justifyContent: "flex-end", gap: "16px" ,alignItems:"center", }}>

        {/* Save Button - saves to localStorage + API */}
    <button
    //  className="buttonStyle"
     style={{ display: "flex", alignItems: "center",fontFamily: "inherit",fontWeight: "bold",borderRadius:"5px" }}
    
      onClick={async () => {
        if (
          typeof roiFilterTemp !== "number" ||
          typeof appreciationFilterTemp !== "number" ||
          isNaN(roiFilterTemp) ||
          isNaN(appreciationFilterTemp)
        ) {
          alert("⚠️ Please set valid values for ROI and Appreciation.");
          return;
        }

        // Save to local storage
        localStorage.setItem("fliROIFilter", roiFilterTemp);
        localStorage.setItem("fliApprFilter", appreciationFilterTemp);

        // Normalize for API
        const roiNormalized = roiFilterTemp / 100;
        const apprNormalized = appreciationFilterTemp / 100;

        try {

          const response = await fetch(
            "https://beta.flowlogic.com/api/users/preference/update/",
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
              body: JSON.stringify({
                roi_weightage: roiNormalized,
                appr_weightage: apprNormalized,
              }),
            }
          );

          console.log("API Endpoint: https://beta.flowlogic.com/api/users/preference/update");
          console.log("Sent Payload:", {
            roi_weightage: roiNormalized,
            appr_weightage: apprNormalized,
          });
          console.log("Response Status:", response.status);

          const data = await response.json();
          console.log("Response JSON:", data);
      toast.success("FLI updated");


          if (!response.ok) {
            throw new Error(`Server responded with status ${response.status}`);
          }

          console.log(" Preferences saved successfully.");
        } catch (err) {
          console.error(" Failed to update preferences:", err);
        }
      }}
    >
      Save
    </button>
    
    {/* Apply Button - only updates state */}
    <button
  //  className="buttonStyle"
      style={{ display: "flex", alignItems: "center",  background: "#1c8f7d",
  color: "#fff",fontFamily: "inherit",fontWeight: "bold",borderRadius:"5px"}}
      onClick={() => {
        setFliROIFilter(roiFilterTemp);
        setFliApprFilter(appreciationFilterTemp);
        setApplyClicked(true);
      toast.success("FLI applied");

        console.log("✅ State applied locally");
      }}
    >
      Apply
    </button>


  </div>
</div>


</div>



)}
</div>
                  )}
                
                

                  {(roiFilter !== "All" ||
                    appreciationFilter !== "All" ||
                    scoreFilter !== "All" ||
                    minSales !== sliderMinSales ||
                    maxSales !== sliderMaxSales ||
                    currentView == "list") && (
                    <span
                      onClick={() => {
                        // Now show "Clearing filters..." message
                        setIsLoading(true);
                        // document.querySelector(".mapboxgl-ctrl-geocoder--input").value = "";
                        const input = document.querySelector(
                          ".mapboxgl-ctrl-geocoder--input"
                        );
                        if (input) {
                          input.value = "";
                        }

                        if (map.getLayer("state-boundary")) {
                          map.removeLayer("state-boundary");
                        }
                        if (map.getLayer("highlighted-region")) {
                          map.removeLayer("highlighted-region");
                        }
                        if (map.getSource("state-boundary")) {
                          map.removeSource("state-boundary");
                        }
                        setPopupInstance(null);
                        if (popupInstance) {
                          popupInstance.remove();
                          setPopupInstance(null);
                          // console.log("after drag small popup", popupInstance);
                        }
                        closePopup();

                        map.flyTo({
                          // center: [-95.7129, 37.0902],
                          // zoom: 3.5,
                          center: isSubscribed
                            ? [-95.7129, 37.0902]
                            : [-86.2583, 39.8494],
                          zoom: isSubscribed ? 3.5 : 9,
                          essential: true,
                        });
                        // Listen for when flyTo completes
                        map.once("moveend", () => {
                          setShowROIFilter(false);
                          setShowAppreciationFilter(false);
                          setShowScoreFilter(false);
                          setShowPriceFilter(false);
                          setRoiFilter("All");
                          setAppreciationFilter("All");
                          setScoreFilter("All");
                          setMinSales(sliderMinSales);
                          setMaxSales(sliderMaxSales);
                          // Optional delay to show message briefly
                          setTimeout(() => {
                            setIsLoading(false);
                          }, 600);
                        });
                      }}
                      style={{
                        // backgroundColor: '#1976d2',  // Same as Button color
                        color: "#1c8f7d",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        textDecoration: "none",
                        display: "inline-block",
                        fontWeight: 500,
                        cursor: "pointer",
                        userSelect: "none",
                        marginLeft: "8px",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      Clear Filters
                    </span>
                  )}{" "}
                  {/* <TextField
                          label="Crime Index"
                          variant="outlined"
                          size="small"
                          value={crimeIndexFilter}
                          onChange={(e) => {
                          const val = e.target.value;
                          setCrimeIndexFilter(val);
                          setActiveMetric("score");
                          // also update score filter
                          // if (val && val !== " ") {
                          //   setScoreFilter(val);
                          // } else {
                          //   setScoreFilter("All"); // reset if cleared
                          // }
                        }}
                        /> */}
                </div>
              )}
            </div>
          ) : (
            <div
              class="subHeaderOuter"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <div class="filterOuter" style={{ flex: 1 }}>
                <h4>My Favorites</h4>
              </div>
              <div
                style={{
                  flex: 6,
                  marginTop: "15px",
                  justifyContent: "flex-end",
                }}
              >
                {/* <div style={{ marginTop: '15px', justifyContent: 'flex-end' }}> */}
                <div className="compareContainer">
                  <Button
                    variant="contained"
                    isCompareClicked
                    // className={`filter-button ${showAppreciationFilter ? 'filterOuteractive' : ''}`} // Conditionally apply 'filterOuteractive'
                    className={`${
                      !isCompareClicked ? "compare-active" : "compare-inactive"
                    }`}
                    onClick={() => {
                      setCurrentView("list");
                      // setIsCompareClicked(true);
                      setIsCompareClicked(!isCompareClicked);
                      // if(isCompareClicked===false){
                      setCompareList([]);
                      setSearchPincode(""); // to avoid the color selected

                      //  setPopupHTML(null);
                      // setCheckedItems({});
                      
                      document.getElementById("detailed_popup").style.display =
                        "none";
                      // document.getElementById("detailed_popup").innerHTML = popupHTML;
                      setPopupHTML(null);

                      // }
                    }}
                  >
                    {"Compare"}
                    {/* {(showAppreciationFilter || window.innerWidth <= 768) && (
                        <div className="slider-container appr_slider">
                            <ButtonFilter filterType="appreciation" selectedValue={appreciationFilter}  onClick={handleSliderChange} />
                        </div>
                    )
                    } */}
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div className="viewMainOuter">
            <div class="viewOuter">
              <div class="views">
                <span>
                  <a
                    href="#"
                    onClick={() => handleViewChange("list")}
                    className={currentView === "list" ? "active" : "inactive"}
                  >
                    {currentView === "list" ? (
                      <img src="/assets/list-flow-active.svg" />
                    ) : (
                      <img src="/assets/list-flow.svg" />
                    )}
                    List
                  </a>
                </span>
                <span class="split">
                  {" "}
                  <a
                    href="#"
                    onClick={() => handleViewChange("split")}
                    className={currentView === "split" ? "active" : "inactive"}
                  >
                    {currentView === "split" ? (
                      <img src="/assets/split-flow-active.svg" />
                    ) : (
                      <img src="/assets/split-flow.svg" />
                    )}
                    Split
                  </a>
                </span>
                <span>
                  <a
                    href="#"
                    onClick={() => handleViewChange("map")}
                    className={currentView === "map" ? "active" : "inactive"}
                  >
                    {currentView === "map" ? (
                      <img src="/assets/map-flow-active.svg" />
                    ) : (
                      <img src="/assets/map-flow.svg" />
                    )}
                    Map
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mainOuter">
          <ToastContainer position="top-right" autoClose={3000} />
          {currentView !== "map" && (
            <div
              className="listOuter"
              style={{
                width:
                  currentView === "list"
                    ? popupHTML
                      ? "70%" // list + popup
                      : "100%" // list only
                    : "38%", // split view
                    //  overflowX: "auto", 
                // transition: 'width 0.2s ease',
              }}
            >
              <div
                className="property-table"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "800px",
                }}
              >
                {/* Header */}
                <div
                  className="property-header"
                  style={{
                    display: "flex",
                    fontWeight: "bold",
                    // borderBottom: "2px solid #000",
                    padding: "0 8px",
                    //  width: currentView === "list"  ? "109%" : "105%",
                      width:
      currentView === "list"
        ? activeTab !== "favorites"
          ? "109%"
          : "99%"
        : activeTab !== "favorites"
          ? "105%"
          : "98%",
                  }}
                >
                  <div className="Zipcode">Zipcode</div>
                  {/* <div style={{ flex: 1 }}>Zipcode</div> */}

                  <div className="roi"
                    style={{  cursor: "pointer" }}
                    onClick={() => {
                      if (sortKey === "roi"){
                        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                        console.log("sortOrder**** bfr  ", sortOrder);
                      }
                      else {
                        setSortKey("roi");
                        setSortOrder("desc");
                      }
                        if( activeTab !== "favorites"){
                      setPropertyList((prevList) => [
                        ...sortProperties(
                          [...prevList],
                          "roi",
                          sortKey === "roi"
                            ? sortOrder === "asc"
                              ? "desc"
                              : "asc"
                            : "desc"
                        ),
                      ]);
                    }
                    else{
                     setFavoritePropertyList((prevList) => [
                      ...sortProperties(
                        [...prevList],
                        "roi",
                        sortKey === "roi"
                          ? sortOrder === "asc"
                            ? "desc"
                            : "asc"
                          : "desc"
                      ),
                    ]);
                  }
                    }}
                  >
                    ROI {getSortArrow("roi")}
                  </div>

                  <div
                   className="Appr"
                    style={{  cursor: "pointer" }}
                    onClick={() => {
                      if (sortKey === "appreciation")
                        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                      else {
                        setSortKey("appreciation");
                        setSortOrder("desc");
                      }
                        if( activeTab !== "favorites"){
                      setPropertyList((prevList) => [
                        ...sortProperties(
                          [...prevList],
                          "appreciation",
                          sortKey === "appreciation"
                            ? sortOrder === "asc"
                              ? "desc"
                              : "asc"
                            : "desc"
                        ),
                      ]);
                    } else{
                      setFavoritePropertyList((prevList) => [
                      ...sortProperties(
                        [...prevList],
                        "appreciation",
                        sortKey === "appreciation"
                          ? sortOrder === "asc"
                            ? "desc"
                            : "asc"
                          : "desc"
                      ),
                    ]);
                  }
                    }}
                  >
                    Appr (%) {getSortArrow("appreciation")}
                  </div>

                  <div
                   className="score"
                    style={{  cursor: "pointer" }}
                    onClick={() => {
                      if (sortKey === "score")
                        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                      else {
                        setSortKey("score");
                        setSortOrder("desc");
                      }
                     if( activeTab !== "favorites"){
                      setPropertyList((prevList) => [
                        ...sortProperties(
                          [...prevList],
                          "score",
                          sortKey === "score"
                            ? sortOrder === "asc"
                              ? "desc"
                              : "asc"
                            : "desc"
                        ),
                      ]);
                    }
                    else{
                       setFavoritePropertyList((prevList) => [
                      ...sortProperties(
                        [...prevList],
                        "score",
                        sortKey === "score"
                          ? sortOrder === "asc"
                            ? "desc"
                            : "asc"
                          : "desc"
                      ),
                    ]);
                  }
                      
                    }}
                  >
                    FLI {getSortArrow("score")}
                  </div>

                  <div
                   className="sales"
                    style={{  cursor: "pointer" }}
                    onClick={() => {
                      if (sortKey === "sales")
                        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                      else {
                        setSortKey("sales");
                        setSortOrder("desc");
                      }
                      setPropertyList((prevList) => [
                        ...sortProperties(
                          [...prevList],
                          "sales",
                          sortKey === "sales"
                            ? sortOrder === "asc"
                              ? "desc"
                              : "asc"
                            : "desc"
                        ),
                      ]);
                    }}
                  >
                    Home Value {getSortArrow("sales")}
                  </div>

                  {currentView === "list" && ( 
                    <div  className="Rent">Rent</div>
                  )}
                  {/* <div className="City" >City</div> */}
                   {!isMobile && <div className="City">City</div>}
                  <div className="State">State</div>
                  {activeTab !== "favorites" && (
                    <div className="Action">Action</div>
                  )}
                </div>

                {/* Body */}
                <div   style={{ flex: 1 }}>
                  {isLoading ? (
                    <div className="loading-message">Loading...</div>
                  ) : filteredList.length === 0 ? (
                    <div className="no-properties">
                      Data loading .. please wait
                    </div>
                  ) : (
                    <AutoSizer>
                      {({ height, width }) => (
                        <List
                          height={height}
                          width={width}
                          rowCount={filteredList.length}
                          rowHeight={40}
                          overscanRowCount={5}
                          rowRenderer={({ index, key, style }) => {
                            const property = filteredList[index];
                            if (!property) return null;

                            const highlightClass =
                              searchPincode === property.zipcode
                                ? "rowWrapper highlight"
                                : compareList.includes(property.zipcode)
                                ? "rowWrapper highlight-compare"
                                : compareList.length >= 4 &&
                                  !compareList.includes(property.zipcode)
                                ? "rowWrapper disabled-row"
                                : "rowWrapper ";

                            return (
                              <div
                                key={key}
                                className={highlightClass}
                                // className="rowWrapper"

                                style={{
                                  ...style,
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "0 8px",
                                  borderBottom: "1px solid #ccc",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (isCompareClicked) {
                                    if (
                                      compareList.length >= 4 &&
                                      !compareList.includes(property.zipcode)
                                    )
                                      return;
                                    handleCompare(property.zipcode);
                                  } else {
                                    handleRowClick(
                                      property.zipcode,
                                      map,
                                      setCurrentPopup,
                                      currentView
                                    );
                                  }
                                }}
                              >
                                {/* Zipcode + optional checkbox */}
                                <div
                                  className="property-cell Zipcode"
                                  style={{
                                   
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {currentView === "list" &&
                                    activeTab === "favorites" &&
                                    isCompareClicked && (
                                      <input
                                        type="checkbox"
                                        checked={compareList.includes(
                                          property.zipcode
                                        )}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleCompare(property.zipcode);
                                        }}
                                        style={{ marginRight: "5px" }}
                                      />
                                    )}
                                  {property.zipcode}
                                </div>
                                <div
                                  className="property-cell roi"
                                  style={{
                                   
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {property.roi}%
                                </div>
                                <div
                                  className="property-cell Appr"
                                  style={{
                                  
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {property.appreciation}%
                                </div>
                                <div
                                  className="property-cell score"
                                  style={{
                                 
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {property.score}
                                </div>
                                <div
                                  className="property-cell sales"
                                  style={{
                                   
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {formatCurrency(property.sales)}
                                </div>
                                {currentView === "list" && (
                                  <div
                                    className="property-cell Rent"
                                    style={{
                                    
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {formatCurrency(property.rent)}
                                  </div>
                                )}
            

                                {!isMobile && (
  <div
    className="property-cell City"
    style={{
      display: "flex",
      alignItems: "center",
    }}
  >
    {currentView === "list"
      ? property.city
      : property.city && property.city.length > 9
      ? property.city.substring(0, 9) + ".."
      : property.city}
  </div>
)}
                                <div
                                  className="property-cell State"
                                  style={{
                                   
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {property.state}
                                </div>

                                {/* Action */}
                                {activeTab !== "favorites" && (
                                  <div
                                    className="property-cell"
                                    style={{
                                    
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {favoriteZipcodes.includes(
                                      property.zipcode
                                    ) ? (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDeleteClick(
                                            e,
                                            property.zipcode,
                                            true
                                          );
                                        }}
                                        style={{
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <img
                                          src="/assets/favorite-G.svg"
                                          alt="Remove Favorite"
                                          width={16}
                                          height={16}
                                        />
                                      </button>
                                    ) : (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          toggleFavorite(
                                            property.zipcode,
                                            false
                                          );
                                        }}
                                        style={{
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <img
                                          src="/assets/not_favorite.svg"
                                          alt="Add Favorite"
                                          width={16}
                                          height={16}
                                        />
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            );
                          }}
                        />
                      )}
                    </AutoSizer>
                  )}
                </div>
              </div>

              {/* Confirmation Modal */}
              {showConfirmModal && zipToRemove && (
                <ConfirmModal
                  visible={showConfirmModal}
                  message={`Are you sure you want to remove <br/><span className="zipHighlight">${zipToRemove.zipcode}</span> zipcode from favorites?`}
                  onConfirm={handleConfirm}
                  onCancel={handleCancel}
                />
              )}
            </div>
          )}
          {/* {currentView === 'list' &&( */}
          <div
            id="detailed_popup"
            className="popup-sidebar"
            style={{
              width: "30%",
              display: "none",
              // overflow: 'auto',
              // transition: 'width 0.2s ease',
            }}
            //dangerouslySetInnerHTML={{ __html: popupHTML }}
          />
          <div
            id="map"
            style={{ flex: 1, height: "100%", position: "relative" }}
          >
            <div ref={mapContainer} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
      </div>
      <div style={{ zIndex: 100 }}>
        {/* EULA Modal */}
        <Modal
          isOpen={showEulaModal}
          onRequestClose={() => setShowEulaModal(false)}
          contentLabel="EULA"
          style={{
            content: {
              width: "80%",
              maxWidth: "900px",
              height: "80vh",
              margin: "auto",
              padding: 0,
              display: "flex",
              flexDirection: "column",
              position: "relative",
            },
          }}
        >
          {/* Header with Close button */}
          <div
            style={{
              padding: "10px",
              background: "#f5f5f5",
              borderBottom: "1px solid #ccc",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 style={{ margin: 0 }}>Flowlogic End User License Agreement</h3>
            {/* <button
              onClick={() => setShowEulaModal(false)}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ✕
            </button> */}
          </div>

          {/* Scrollable HTML Content */}
          <div
            ref={scrollRef}
            onScroll={handleScroll}
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "15px",
              position: "relative",
            }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />

          {/* Agree button — only shows after scroll to bottom */}
          {canAccept && (
            <div
              style={{
                padding: "20px",
                textAlign: "right",
                borderTop: "1px solid #ccc",
              }}
            >
              <button
                // className="btn btn-primary"
                className="btn btn-flow"
                onClick={handleAgree}
              >
                I Accept
              </button>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
};
export default PointScreen;